<template>

    <div id="topscribeEditorComponent" class="w-100 h-100" style="background-color: #CCCCCC;">

        <b-modal no-close-on-backdrop no-close-on-esc centered hide-header hide-footer size="sm" body-class="align-items-center d-flex justify-content-around" v-model="showProgressSpinner"><b-spinner></b-spinner> <span>Processing your input ...</span></b-modal>

        <template v-if="!readonly && configuration && configuration.shortcuts && !dialogOpen && !expansionManagerActive">
            <template v-for="(shortcut, index) in configuration.shortcuts">
                <vue-keypress key-event="keydown" @success="onAction(shortcut.action)" :key-code="shortcut.keyCode" :modifiers="shortcut.modifiers" :preventDefault="true" :key="'shortcut_'+index" v-if="shortcut.keyCode"></vue-keypress>
            </template>
            <!-- expansions -->
            <template v-for="(trigger,index) in expansionTriggers">
                <vue-keypress key-event="keydown" @success="checkForExpansion(trigger)" :keyCode="trigger.keyCode" :preventDefault="trigger.preventDefault" :key="'expansion_trigger_'+index" />
            </template>
            <!-- Backspace to undo last expansion -->
            <vue-keypress key-event="keydown" @success="undoLastExpansions" :keyCode="8" :preventDefault="false" key="expansion_undo" />
            <!--this key press handles the visibilty of the cursor once bottom of the page is reached-->
            <vue-keypress key-event="keyup" @success="onNewParagraph" :keyCode="13" :preventDefault="false" key="new_paragraph" />
        </template>

        <div id="topscribeEditorWrapper" :class="editorWrapperClass">
            <div id="mainMenuWrapper" style="background-color: #FFF;" v-if="configurationReady" class="pt-2 pb-1">
                <ejs-menu ref="mainMenu" :items="mainMenuItems" @beforeItemRender="beforeMenuItemRender" @select="menuItemSelected" style="z-index: 3;"></ejs-menu>
            </div>

            <ejs-richtexteditor id="richTextEditorId"
                                ref="topscribeEditor"
                                :value="documentContent"
                                :enabled="!readonly"
                                :keyConfig="rteKeyConfig"
                                :undoRedoSteps="300"
                                class="flex-grow-1 overflow-hidden d-flex h-100 m-auto pt-0 pl-2 pr-2 pb-0 bg-white shadow p-3 mb-5 bg-white rounded"
                                :htmlAttributes="{ style: 'font-size: 25px;'}"
                                style="z-index: 1;"
                                :saveInterval="autosaveInterval"
                                :pasteCleanupSettings="rtePasteCleanupSettings"
                                @afterPasteCleanup="rteAfterPasteCleanup"
                                @change="documentContentChanged"
                                @actionBegin="rteActionBegin"
                                @actionComplete="rteActionComplete">
            </ejs-richtexteditor>

            <!--<ejs-contextmenu ref="contextMenu"
                     target="#topscribeEditorWrapper .e-rte-content"
                     :items="contextMenuItems"
                     @beforeOpen="beforeContextMenuOpen"
                     @select="menuItemSelected"
                     @onClose="contextMenuClosed"
                     v-if="!readonly"></ejs-contextmenu>-->

            <div id="statusArea" class="d-flex flex-column bg-light" v-if="!readonly">
                <div id="statusBar" class="d-flex pl-2">
                    <div id="statusBarInfoArea" class="flex-grow-1 d-flex align-items-center" v-html="currentValidationStatus"></div>
                    <div class="d-flex align-items-center" v-html="currentDraftVersionStatus">
                    </div>
                    <b-button id="statusAreaToggleButton" size="sm" variant="light" @click="showValidationMessages = !showValidationMessages" v-if="currentValidationMessages && currentValidationMessages.length">
                        <i class="fas fa-chevron-down" v-if="showValidationMessages"></i>
                        <i class="fas fa-chevron-up" v-else></i>
                    </b-button>
                </div>
                <div id="statusAreaDetails" class="flex-fill overflow-auto">
                    <b-collapse id="statusBarCollapse" v-model="showValidationMessages">
                        <b-list-group flush v-if="currentValidationMessages && currentValidationMessages.length">
                            <b-list-group-item button
                                               :variant="(validationMessage.severity == 'Warning') ? 'warning' : 'danger'"
                                               @click="validationMessageClicked(validationMessage)"
                                               v-for="(validationMessage, index) in currentValidationMessages"
                                               :key="index">
                                <strong>{{ validationMessage.code }}:&nbsp;</strong>{{ validationMessage.message }}
                            </b-list-group-item>
                        </b-list-group>
                    </b-collapse>
                </div>
            </div>
        </div>

        <topscribe-expansion-manager v-model="expansionManagerActive"
                                     :mode="currentExpansionManagerMode"
                                     :system-expandables-incoming="systemExpandables"
                                     :highlighted-long="highlightedLong"
                                     @saveExpansionModificationsToDB="saveExpansionModifications"
                                     @change="handleDialogActiveChanged">
        </topscribe-expansion-manager>

        <topscribe-turn-dialog :configuration="dialogs.turn.dialogConfiguration"
                               v-model="dialogs.turn.dialogOpen"
                               :mode="currentSectionMode"
                               :current-editor-section="currentEditorSection"
                               :init-options="currentDialogInitOptions"
                               @configurationChanged="dialogConfigurationChanged"
                               @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                               @sectionsInserted="sectionsInserted"
                               @sectionUpdated="sectionUpdated"
                               @cancelled="dialogCancelled"
                               v-if="!readonly && configuration && configuration.availableDialogs.turn"></topscribe-turn-dialog>

        <topscribe-session-dialog :configuration="dialogs.session.dialogConfiguration"
                                  v-model="dialogs.session.dialogOpen"
                                  :mode="currentSectionMode"
                                  :current-editor-section="currentEditorSection"
                                  @configurationChanged="dialogConfigurationChanged"
                                  @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                  @sectionsInserted="sectionsInserted"
                                  @sectionUpdated="sectionUpdated"
                                  @cancelled="dialogCancelled"
                                  v-if="!readonly && configuration && configuration.availableDialogs.session"></topscribe-session-dialog>

        <topscribe-witness-status-dialog :configuration="dialogs.witnessstatus.dialogConfiguration"
                                         v-model="dialogs.witnessstatus.dialogOpen"
                                         :mode="currentSectionMode"
                                         :current-editor-section="currentEditorSection"
                                         @configurationChanged="dialogConfigurationChanged"
                                         @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                         @sectionsInserted="sectionsInserted"
                                         @sectionUpdated="sectionUpdated"
                                         @cancelled="dialogCancelled"
                                         v-if="!readonly && configuration && configuration.availableDialogs.witnessstatus"></topscribe-witness-status-dialog>

        <topscribe-witness-examination-dialog :configuration="dialogs.witnessexamination.dialogConfiguration"
                                              v-model="dialogs.witnessexamination.dialogOpen"
                                              :mode="currentSectionMode"
                                              :current-editor-section="currentEditorSection"
                                              @configurationChanged="dialogConfigurationChanged"
                                              @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                              @sectionsInserted="sectionsInserted"
                                              @sectionUpdated="sectionUpdated"
                                              @cancelled="dialogCancelled"
                                              v-if="!readonly && configuration && configuration.availableDialogs.witnessexamination"></topscribe-witness-examination-dialog>

        <topscribe-speaker-dialog :configuration="dialogs.speaker.dialogConfiguration"
                                  v-model="dialogs.speaker.dialogOpen"
                                  :mode="currentSectionMode"
                                  :current-editor-section="currentEditorSection"
                                  @configurationChanged="dialogConfigurationChanged"
                                  @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                  @sectionsInserted="sectionsInserted"
                                  @sectionUpdated="sectionUpdated"
                                  @cancelled="dialogCancelled"
                                  v-if="!readonly && configuration && configuration.availableDialogs.speaker"></topscribe-speaker-dialog>

        <topscribe-speaker-subsection-dialog :configuration="dialogs.speakersubsection.dialogConfiguration"
                                             v-model="dialogs.speakersubsection.dialogOpen"
                                             :mode="currentSectionMode"
                                             :current-editor-section="currentSpeakerSubSection ? currentSpeakerSubSection : currentEditorSection"
                                             @configurationChanged="dialogConfigurationChanged"
                                             @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                             @sectionsInserted="sectionsInserted"
                                             @sectionUpdated="sectionUpdated"
                                             @cancelled="dialogCancelled"
                                             v-if="!readonly && configuration && configuration.availableDialogs.speakersubsection"></topscribe-speaker-subsection-dialog>

        <topscribe-event-dialog :configuration="dialogs.event.dialogConfiguration"
                                v-model="dialogs.event.dialogOpen"
                                :mode="currentSectionMode"
                                :current-editor-section="currentEditorSection"
                                @configurationChanged="dialogConfigurationChanged"
                                @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                @sectionsInserted="sectionsInserted"
                                @sectionUpdated="sectionUpdated"
                                @cancelled="dialogCancelled"
                                v-if="!readonly && configuration && configuration.availableDialogs.event"></topscribe-event-dialog>

        <topscribe-miscellaneous-event-dialog :configuration="dialogs.miscevent.dialogConfiguration"
                                              v-model="dialogs.miscevent.dialogOpen"
                                              :mode="currentSectionMode"
                                              :current-editor-section="currentEditorSection"
                                              @configurationChanged="dialogConfigurationChanged"
                                              @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                              @sectionsInserted="sectionsInserted"
                                              @sectionUpdated="sectionUpdated"
                                              @cancelled="dialogCancelled"
                                              v-if="!readonly && configuration && configuration.availableDialogs.miscevent"></topscribe-miscellaneous-event-dialog>

        <topscribe-exhibit-dialog :configuration="dialogs.exhibit.dialogConfiguration"
                                  v-model="dialogs.exhibit.dialogOpen"
                                  :mode="currentSectionMode"
                                  :current-editor-section="currentEditorSection"
                                  @configurationChanged="dialogConfigurationChanged"
                                  @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                  @sectionsInserted="sectionsInserted"
                                  @sectionUpdated="sectionUpdated"
                                  @cancelled="dialogCancelled"
                                  v-if="!readonly && configuration && configuration.availableDialogs.exhibit"></topscribe-exhibit-dialog>

        <topscribe-adjournment-dialog :configuration="dialogs.adjournment.dialogConfiguration"
                                      v-model="dialogs.adjournment.dialogOpen"
                                      :mode="currentSectionMode"
                                      :current-editor-section="currentEditorSection"
                                      @configurationChanged="dialogConfigurationChanged"
                                      @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                      @sectionsInserted="sectionsInserted"
                                      @sectionUpdated="sectionUpdated"
                                      @cancelled="dialogCancelled"
                                      v-if="!readonly && configuration && configuration.availableDialogs.adjournment"></topscribe-adjournment-dialog>

        <topscribe-interpreter-dialog :configuration="dialogs.interpreter.dialogConfiguration"
                                      v-model="dialogs.interpreter.dialogOpen"
                                      :mode="currentSectionMode"
                                      :current-editor-section="currentEditorSection"
                                      @configurationChanged="dialogConfigurationChanged"
                                      @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                      @sectionsInserted="sectionsInserted"
                                      @sectionUpdated="sectionUpdated"
                                      @cancelled="dialogCancelled"
                                      v-if="!readonly && configuration && configuration.availableDialogs.interpreter"></topscribe-interpreter-dialog>

        <topscribe-charge-and-plea-dialog :configuration="dialogs.chargeandplea.dialogConfiguration"
                                          v-model="dialogs.chargeandplea.dialogOpen"
                                          :mode="currentSectionMode"
                                          :current-editor-section="currentEditorSection"
                                          @configurationChanged="dialogConfigurationChanged"
                                          @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                          @sectionsInserted="sectionsInserted"
                                          @sectionUpdated="sectionUpdated"
                                          @cancelled="dialogCancelled"
                                          v-if="!readonly && configuration && configuration.availableDialogs.chargeandplea"></topscribe-charge-and-plea-dialog>

        <topscribe-retaining-style-dialog v-model="dialogs.retainingstyle.dialogOpen"
                                          :mode="currentSectionMode"
                                          :current-editor-section="currentEditorSection"
                                          @configurationChanged="dialogConfigurationChanged"
                                          @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                          @sectionsInserted="sectionsInserted"
                                          @sectionUpdated="sectionUpdated"
                                          @cancelled="dialogCancelled"
                                          v-if="!readonly && configuration && configuration.availableDialogs.retainingstyle"></topscribe-retaining-style-dialog>

        <topscribe-address-dialog :configuration="dialogs.address.dialogConfiguration"
                                  v-model="dialogs.address.dialogOpen"
                                  :mode="currentSectionMode"
                                  :current-editor-section="currentEditorSection"
                                  @configurationChanged="dialogConfigurationChanged"
                                  @beforeSectionsInsertOrUpdate="beforeSectionsInsertOrUpdate"
                                  @sectionsInserted="sectionsInserted"
                                  @sectionUpdated="sectionUpdated"
                                  @cancelled="dialogCancelled"
                                  v-if="!readonly && configuration && configuration.availableDialogs.address"></topscribe-address-dialog>

        <topscribe-speaker-consolidation-dialog :speakerConfiguration="dialogs.speaker.dialogConfiguration"
                                                v-model="speakerConsolidation.dialogOpen"
                                                :speaker-section-details="speakerConsolidation.speakerSectionDetails"
                                                @speakerDataChanged="updateSections"
                                                v-if="!readonly && configuration && configuration.availableDialogs.speaker"
                                                @change="handleDialogActiveChanged"></topscribe-speaker-consolidation-dialog>

        <b-modal v-model="showSourceModal"
                 size="xl"
                 title="Transcript Source Code"
                 scrollable
                 ok-only
                 ok-title="Close"
                 @show="peserveCurrentEditorPosition"
                 @hidden="restoreCurrenEditPosition">
            <pre lang="html">{{ prettyPrintHtml(getCurrentDocumentContent()) }}</pre>
        </b-modal>

        <b-modal v-model="showShortcutsModal"
                 size="lg"
                 title="Available Shortcuts"
                 scrollable
                 ok-only
                 ok-title="Close"
                 @show="peserveCurrentEditorPosition"
                 @hidden="restoreCurrenEditPosition">
            <template v-if="shortcutsForInfo">

                <b-list-group flush>
                    <b-list-group-item v-if="shortcutsForInfo.length == 0">
                        No short cuts registered
                    </b-list-group-item>
                    <b-list-group-item v-for="(shortcut, index) in shortcutsForInfo" :key="index" class="border-0 py-0">
                        <hr v-if="shortcut.separator" class="my-1" />
                        <b-row v-else>
                            <b-col cols="3">{{ shortcut.text }}</b-col>
                            <b-col cols="9">{{ shortcut.action.description }}</b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
            </template>
        </b-modal>

        <b-modal v-model="showAboutModal"
                 size="sm"
                 title="About"
                 ok-only
                 ok-title="Close"
                 v-if="configuration"
                 @show="peserveCurrentEditorPosition"
                 @hidden="restoreCurrenEditPosition">
            TOPScribe V{{ configuration.version }}
        </b-modal>

        <b-modal :visible="showStatusErrorModal"
                 title="Status Error"
                 centered
                 hide-header-close
                 no-close-on-backdrop
                 no-close-on-esc
                 cancel-title="Retry"
                 ok-title="Exit"
                 @ok="statusErrorExit"
                 @cancel="statusErrorRetry">
            <template v-if="statusInfo">
                {{ statusInfo.statusMessage }}
            </template>
        </b-modal>

        <b-modal v-model="showImportModal"
                 size="md"
                 title="Import"
                 v-on:ok="importDocumentContent">
            <b-form-file v-model="importFile"
                         placeholder="Choose a file or drop it here..."
                         drop-placeholder="Drop file here..."></b-form-file>
        </b-modal>

        <b-sidebar id="shortcut-sidebar" title="Shortcuts" v-model="showShortcutsSideBar"
                   bg-variant="light"
                   text-variant="dark"
                   style="z-index:2;"
                   class="border-right border-light"
                   width="430px"
                   v-on:shown="shortcutsSideBarShown">
            <div class="px-3 py-2 h-100 small" v-if="shortcutsForInfo">
                <div v-for="(shortcut, index) in shortcutsForInfo" :key="index" class="w-100">
                    <hr v-if="shortcut.separator" class="my-1" />
                    <b-row v-else>
                        <b-col cols="4">{{ shortcut.text }}</b-col>
                        <b-col cols="8">{{ shortcut.action.description }}</b-col>
                    </b-row>
                </div>
                <b-button v-on:click="showShortcutsSideBar=false;" size="sm" class="mt-3">Close Panel</b-button>
            </div>
        </b-sidebar>

        <b-sidebar id="transcript-sidebar" title="Transcription Dialogs" v-model="showTranscriptionSideBar"
                   bg-variant="light"
                   text-variant="dark"
                   style="z-index:2;"
                   class="border-right border-light"
                   right
                   v-on:shown="transcriptionSideBarShown">

            <div v-if="transcriptButtons">
                <div v-for="(transcriptButton, index) in transcriptButtons" :key="index" class="w-100 pl-3 pr-3">
                    <b-button v-on:click="transcriptButton.clicked" variant="outline-success" size="sm" class="w-100 mt-2 pt-2 pb-2">{{ transcriptButton.content }}</b-button>
                </div>
            </div>
            <b-button v-on:click="showTranscriptionSideBar=false;" size="sm" class="m-3 float-right">Close Panel</b-button>
        </b-sidebar>

        <b-sidebar id="search-replace-sidebar" title="Find & Replace" v-model="showFindAndReplaceSideBar"
                   bg-variant="light"
                   style="z-index: 2;"
                   text-variant="dark"
                   class="border-right border-light smaller"
                   v-on:shown="findAndReplaceSideBarShown"
                   left>

            <b-container class="bv-example-row mt-2">
                <b-row class="mb-2">
                    <b-col cols="7">
                        <b-input placeholder="Search for"
                                 v-model="searchFor"
                                 size="sm"
                                 ref="searchFor"
                                 v-on:focus="findAndReplaceInUse=true;"
                                 v-on:blur="findAndReplaceInUse=false;"
                                 v-on:input="resetFindAndReplaceUI"
                                 class="border border-primary">
                        </b-input>
                    </b-col>
                    <b-col>
                        <b-button size="sm" :disabled="searchFor.length<2" @click="findAndReplaceHandler('find')" variant="outline-primary" class="mb-1 w-100">Find</b-button>
                        <b-button size="sm" :disabled="searchFor.length<2" @click="findAndReplaceHandler('find-all')" variant="outline-primary" class="w-100">Find All</b-button>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="7">
                        <b-input placeholder="Replace with"
                                 v-model="replaceWith"
                                 size="sm"
                                 v-on:focus="findAndReplaceInUse=true;"
                                 v-on:blur="findAndReplaceInUse=false;"
                                 v-on:input="resetFindAndReplaceUI"
                                 class="border border-success">
                        </b-input>
                    </b-col>
                    <b-col>
                        <b-button size="sm" :disabled="searchFor.length==0" @click="findAndReplaceHandler('replace-all')" variant="outline-success" class="w-100">Replace All</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-form-group>
                            <b-form-checkbox-group v-model="selectedFindAndReplaceOptions"
                                                   :options="findAndReplaceOptions"
                                                   v-on:change="findAndReplaceHandler('find-all')"
                                                   size="sm"
                                                   name="search-flags"
                                                   stacked></b-form-checkbox-group>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row class="m-auto">
                    <b-alert v-model="showFindAndReplaceAlert" :variant="searchResultsList.length ? 'success' : 'warning'" class="m-auto w-100">
                        {{ findAndReplaceAlertDisplayText }}
                    </b-alert>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button variant="secondary"
                                  v-on:click="showFindAndReplaceSideBar=false;"
                                  size="sm" class="mt-2 w-100">Close Panel</b-button>
                    </b-col>
                </b-row>

                <div class="mt-3" v-if="searchResultsList.length">
                    <b-list-group small flush>
                        <b-list-group-item button active
                                           class="mx-auto rounded"
                                           variant="success"
                                           @click="showSearchResults=!showSearchResults">
                            {{ showSearchResults ? 'Hide results' : 'Show results' }}
                        </b-list-group-item>
                        <b-collapse id="searchResultCollapse" v-model="showSearchResults">
                            <b-list-group-item button
                                               class=""
                                               @click="searchResultItemClicked(searchResult)"
                                               v-for="(searchResult,searchIndex) in searchResultsList"
                                               :key="searchIndex">

                                <span class="font-weight-bold">{{ searchIndex + 1 }}</span>  <span v-html="searchResult.displayText"></span>
                            </b-list-group-item>
                        </b-collapse>
                    </b-list-group>

                </div>
            </b-container>
        </b-sidebar>

        <b-sidebar id="index-sidebar" title="Document Index" v-model="showDocumentNavigator"
                   bg-variant="light"
                   style="z-index: 2;"
                   text-variant="dark"
                   class=""
                   v-on:shown="topscribeDocumentIndexShown"
                   right>

            <b-container class="bv-example-row mt-2">
                <b-row class="mb-2 ml-2">
                    <b-form-group>
                        <b-form-checkbox-group v-model="selectedTopscribeIndexOptions"
                                               :options="topscribeIndexOptions"
                                               v-on:change="buildTopscribeIndex"
                                               size="sm"
                                               name="index-flags"></b-form-checkbox-group>
                    </b-form-group>
                </b-row>

                <div v-if="topscribeSectionList.length">
                    <b-list-group small flush class="rte-color">
                        <div v-for="(topscribeSection,index) in topscribeSectionList" :key="index">
                            <b-list-group-item :class="topscribeSection.dataType=='turn' ? 'rounded small p-1 mb-1 name rte-color' : 'rounded small p-1 mb-1 name rte-color border border-dark ml-2'"
                                               :data-type="topscribeSection.dataType"
                                               @click="topscribeIndexClicked(topscribeSection)"
                                               v-if="checkSectionContent(topscribeSection.dataContent) != null">
                                <span v-html="topscribeSection.dataContent"></span>
                            </b-list-group-item>
                        </div>
                    </b-list-group>
                </div>
            </b-container>
        </b-sidebar>

        <b-modal id="quick-check-modal"
                 ref="quick-check-modal"
                 title="Find expansions"
                 ok-only
                 size="sm"
                 @show="peserveCurrentEditorPosition"
                 @hidden="restoreCurrenEditPosition"
                 v-model="showQuickCheckModal">

            <b-form-input placeholder="... please type at least 2 characters" ref="quickCheckExpansionInput" v-model="expansionFilter"
                          v-on:blur="expansionFilter = ''" size="sm" autofocus></b-form-input>

            <b-list-group class="d-flex" v-if="filteredExpansions && filteredExpansions.length && expansionFilter.length > 1">
                <b-list-group-item v-for="(expansion,index) in filteredExpansions" size="sm" :key="index" class="m-0 p-1 pl-2">
                    <strong>{{ expansion.short }}</strong> |  {{ expansion.long }}
                </b-list-group-item>
            </b-list-group>

        </b-modal>

        <b-modal id="editor-settings-modal"
                 ref="editor-settings-modal"
                 title="Options"
                 v-model="showEditorSettingsModal"
                 no-close-on-esc
                 cancel-title="Cancel"
                 ok-title="Update"
                 @show="updateModelsWithCurrentValues"
                 @ok="updateAllEditorSetting"
                 @cancel="showEditorSettingsModal=false;"
                 @hidden="restoreCurrenEditPosition">
            <b-container fluid>
                <!-- Card 1: Editor Settings -->
                <b-card body-class="p-2" header="Editor Settings" header-bg-variant="light" header-text-variant="dark">
                    <b-row class="mb-2 align-items-center">
                        <b-col cols="6" class="text-sm-right">Orientation</b-col>
                        <b-col cols="6">
                            <b-form-select v-model="newDisplayMode" size="sm" :options="displayModeSettings.dataSource"></b-form-select>
                        </b-col>
                    </b-row>
                </b-card>

                <!-- Card 2: Font Settings -->
                <b-card body-class="p-2" header="Font Settings" header-bg-variant="light" header-text-variant="dark">
                    <b-row class="mb-2 align-items-center">
                        <b-col cols="6" class="text-sm-right">Font family</b-col>
                        <b-col cols="6">
                            <b-form-select v-model="newEditorFontFamily" size="sm" :options="styleOptions.dataSource"></b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="mb-2 align-items-center">
                        <b-col cols="6" class="text-sm-right">Font size</b-col>
                        <b-col cols="6">
                            <b-form-select v-model="newEditorFontSize" size="sm" :options="sizeOptions.dataSource"></b-form-select>
                        </b-col>
                    </b-row>
                </b-card>

                <!-- Card 3: Display Options -->
                <b-card body-class="p-2" header="Display Options" header-bg-variant="light" header-text-variant="dark">
                    <b-row class="mb-2 align-items-center">
                        <b-col cols="6" class="text-sm-right">Colour mode</b-col>
                        <b-col cols="6">
                            <b-form-checkbox v-model="newColorMode" switch class="m-0"></b-form-checkbox>
                        </b-col>
                    </b-row>

                    <b-row class="mb-2 align-items-center">
                        <b-col cols="6" class="text-sm-right">Non-printable characters</b-col>
                        <b-col cols="6">
                            <b-form-checkbox v-model="newShowAllNBSP" switch class="m-0"></b-form-checkbox>
                        </b-col>
                    </b-row>

                    <!-- Optional toggle -->
                    <!--
        <b-row class="mb-2 align-items-center">
          <b-col cols="6" class="text-sm-right">Performance mode</b-col>
          <b-col cols="6">
            <b-form-checkbox v-model="newPerformanceMode" switch class="m-0"></b-form-checkbox>
          </b-col>
        </b-row>
        -->
                </b-card>

            </b-container>
        </b-modal>

    </div>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import VueKeypress from 'vue-keypress';
    import { MenuPlugin } from "@syncfusion/ej2-vue-navigations";
    import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";
    import { RichTextEditorPlugin, HtmlEditor, Count, PasteCleanup } from '@syncfusion/ej2-vue-richtexteditor';
    import { v4 as newUuid } from 'uuid';
    import FileSaver from 'file-saver';
    import { ListViewPlugin } from "@syncfusion/ej2-vue-lists";
    import { ToastPlugin, ToastUtility } from '@syncfusion/ej2-vue-notifications';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import UuidMixins from '../../mixins/UuidMixins';
    import TopscribeTurnDialog from './TopscribeTurnDialog';
    import TopscribeSessionDialog from './TopscribeSessionDialog';
    import TopscribeWitnessStatusDialog from './TopscribeWitnessStatusDialog';
    import TopscribeWitnessExaminationDialog from './TopscribeWitnessExaminationDialog';
    import TopscribeSpeakerDialog from './TopscribeSpeakerDialog';
    import TopscribeSpeakerConsolidationDialog from './TopscribeSpeakerConsolidationDialog';
    import TopscribeSpeakerSubsectionDialog from './TopscribeSpeakerSubsectionDialog';
    import TopscribeEventDialog from './TopscribeEventDialog';
    import TopscribeMiscellaneousEventDialog from './TopscribeMiscellaneousEventDialog';
    import TopscribeExhibitDialog from './TopscribeExhibitDialog';
    import TopscribeAdjournmentDialog from './TopscribeAdjournmentDialog';
    import TopscribeInterpreterDialog from './TopscribeInterpreterDialog';
    import TopscribeChargeAndPleaDialog from './TopscribeChargeAndPleaDialog';
    import TopscribeRetainingStyleDialog from './TopscribeRetainingStyleDialog';
    import TopscribeAddressDialog from './TopscribeAddressDialog';
    import TopscribeExpansionManager from './TopscribeExpansionManager';

    Vue.use(MenuPlugin);
    Vue.use(BootstrapVue);
    Vue.use(ContextMenuPlugin);
    Vue.use(RichTextEditorPlugin);
    //Vue.use(RibbonPlugin);
    Vue.use(ListViewPlugin);
    Vue.use(ToastPlugin, ToastUtility);

    export default {
        name: 'TopscribeEditor',
        mixins: [ErrorsMixin, DateTimeMixin, UuidMixins],
        components: {
            'vue-keypress': VueKeypress,
            'topscribe-turn-dialog': TopscribeTurnDialog,
            'topscribe-session-dialog': TopscribeSessionDialog,
            'topscribe-witness-status-dialog': TopscribeWitnessStatusDialog,
            'topscribe-witness-examination-dialog': TopscribeWitnessExaminationDialog,
            'topscribe-speaker-dialog': TopscribeSpeakerDialog,
            'topscribe-speaker-consolidation-dialog': TopscribeSpeakerConsolidationDialog,
            'topscribe-speaker-subsection-dialog': TopscribeSpeakerSubsectionDialog,
            'topscribe-event-dialog': TopscribeEventDialog,
            'topscribe-miscellaneous-event-dialog': TopscribeMiscellaneousEventDialog,
            'topscribe-exhibit-dialog': TopscribeExhibitDialog,
            'topscribe-adjournment-dialog': TopscribeAdjournmentDialog,
            'topscribe-interpreter-dialog': TopscribeInterpreterDialog,
            'topscribe-charge-and-plea-dialog': TopscribeChargeAndPleaDialog,
            'topscribe-retaining-style-dialog': TopscribeRetainingStyleDialog,
            'topscribe-address-dialog': TopscribeAddressDialog,
            'topscribe-expansion-manager': TopscribeExpansionManager
        },
        provide: {
            // ribbon: [ RibbonFileMenu, RibbonColorPicker ],
            richtexteditor: [HtmlEditor, Count, PasteCleanup]
        },
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            topscribeDocumentId: {
                type: String,
                required: true
            },
            version: {
                type: Number,
                default: null
            },
            localFilename: {
                type: String,
                default: null
            },
            readonly: {
                type: Boolean,
                default: false
            },
            startWithPerformanceMode: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                
                showEditorSettingsModal: false,
                showQuickCheckModal: false,
                sourceCodeAction: {
                    type: 'sourcecode',
                    dialogName: ''
                },
                showGlossary: false,
                showShortcutsSideBar: false,
                showTranscriptionSideBar: false,

                showFindAndReplaceSideBar: false,
                showSearchResults: false,
                searchFor: '',
                replaceWith: '',
                findAndReplaceOptions: [
                    { text: 'Match case', value: 'match-case' },
                    { text: 'Whole words only', value: 'whole-word-only' }
                    /*{ text: 'Show editable only', value: 'editable-only' }*/
                ],
                selectedFindAndReplaceOptions: [], // v-model for the search and replace options
                searchResults: [],
                searchResultsList: [],
                searchResultsCounter: 0,
                searchOffset: 0,
                findAndReplaceInUse: false,
                showFindAndReplaceAlert: false,
                findAndReplaceAlertDisplayText: '',

                // right hand side document index
                showDocumentNavigator: false,
                topscribeSectionList: [],
                topscribeIndexOptions: [
                    { text: 'Turn', value: 'turn', disabled: true },
                    { text: 'Session', value: 'session' },
                    { text: 'Speaker', value: 'speaker' },
                    { text: 'Witness', value: 'witness' },
                    { text: 'Event', value: 'event' }, 
                    { text: 'Exhibit', value: 'exhibit' },
                    { text: 'Adjournment', value: 'adjournment' },
                    { text: 'Interpreter', value: 'interpreter' }

                ],
                selectedTopscribeIndexOptions: ['turn'],


                
                systemExpandables: [],
                systemExpandablesLookup: {},
                expansionTriggers: [
                    {
                        key: 'space',
                        keyCode: 32, // space bar
                        modifiers: [],
                        preventDefault: false,
                    },
                    {
                        key: ',',
                        keyCode: 188,
                        modifiers: [],
                        preventDefault: false,
                    },
                    {
                        key: ';',
                        keyCode: 186,
                        modifiers: [],
                        preventDefault: false,
                    },
                    {
                        key: ':',
                        keyCode: 186,
                        modifiers: [],
                        preventDefault: false,
                    },
                    {
                        key: '.',
                        keyCode: 190,
                        modifiers: [],
                        preventDefault: false,
                    },
                    {
                        key: '!',
                        keyCode: 49,
                        modifiers: [],
                        preventDefault: false,
                    },
                    {
                        key: '?',
                        keyCode: 191,
                        modifiers: [],
                        preventDefault: false,
                    },
                    {
                        key: "'",
                        keyCode: 222,
                        modifiers: [],
                        preventDefault: false,
                    }
                ],

                lastUsedExpansion: null,
                expansionFilter: '',
                newExpansion: {
                    uuid: null,
                    short: '',
                    long: '',
                    lastUsed: null,
                    locked: false,
                    modification: '',
                    preserve: false
                },

                spaceBarKeyCode: 32,

                altkeyArray: ['altKey'],

                expansionManagerActive: false,
                currentExpansionManagerMode: 'manage-expansions',
                highlightedLong: '',


                displayMode: 'Portrait',

                fileSettings: {
                    visible: true,
                    menuItems: [
                        {
                            text: "Validate",
                            iconCss: "e-icons e-file-new",
                            id: "new",
                            action: {
                                type: "validate"
                            }
                        },
                        { separator: true },
                        {
                            text: "Save draft",
                            iconCss: "e-icons e-save",
                            id: "savedraft",
                            action: {
                                type: "savedraft"
                            }
                        },
                        {
                            text: "Save draft & exit",
                            iconCss: "e-icons e-save",
                            id: "savedraftandexit",
                            action: {
                                type: "savedraftandexit"
                            }
                        },
                        {
                            text: "Save & exit",
                            iconCss: "e-icons e-save",
                            id: "saveandexit",
                            action: {
                                type: "saveandexit"
                            }
                        },
                        {
                            text: "Discard & exit",
                            iconCss: "e-icons e-save",
                            id: "discardandexit",
                            action: {
                                type: "discardandexit"
                            }
                        },
                        { separator: true },
                        {
                            text: "Export to local file", iconCss: "e-icons chevron-left-double", id: "export", "action": { "type": "export" }
                        },
                        {
                            text: "Import from local file",
                            iconCss: "fas-regular fas-cross",
                            id: "import",
                            action: {
                                type: "import"
                            }
                        },
                        { separator: true },
                        {
                            text: "Clear",
                            iconCss: "e-icons insert-right",
                            id: "clear",
                            action: {
                                type: "clear"
                            }
                        },
                        { separator: true },
                        {
                            text: "Exit",
                            iconCss: "e-icons opacity",
                            id: "exit",
                            action: {
                                type: "exit"
                            }
                        }

                    ],
                    select: (args) => {
                        if (args.item && args.item.id) {
                            var menuItem = this.fileSettings.menuItems.find(i => i.id == args.item.id);
                            if (menuItem && menuItem.action) {
                                this.onAction(menuItem.action);
                            }
                        }
                        //args.itemData.alert();
                        //if (args.item.text == 'Save draft') this.saveDocumentContent(true, true);
                        //if (args.item.text == 'Validate') this.validateDocumentContent();
                        //if (args.item.text == 'Clear') this.setCurrentDocumentContent(null);
                        //if (args.item.text == 'Import from local file') this.showImportModal = true;

                    }
                },

                displayModeSettings: { dataSource: ['Portrait', 'Landscape', 'Full width'] },

                // font drop down data
                editorFontFamily: "Calibri",
                styleOptions: {
                    dataSource: ["Arial", "Calibri", "Cambria", "Courier New", "Times New Roman", "Verdana"]
                },
                // font size drop down data
                editorFontSize: '16',
                sizeOptions: {
                    dataSource: ["10", "11", "12", "14", "16", "18", "20", "22", "24"]
                },

                // editorColorSettings: { label: "ON", checked: true, change: (args) => { this.changeColorOptions(args) } },

                // expansionManagerButtonSettings: { content: "Expansion Manager", isToggle: "true", clicked: () => { this.showExpansionManagerModal = true } },
                // shortcutButton: { content: "List of Shortcuts", isToggle: "true", clicked: () => { this.showShortcutsModal = true } },

                // editorFontColor: '#123456',

                // colorPicker: { value: "#CCCCCC", change: (args) => { this.editorFontColor = args.currentValue.hex; this.updateEditorStyle(); } },

                //these key configs for the editor will disable all keyboard shortcuts on the EJ2 rte control
                rteKeyConfig: {
                    'toolbar-focus': '',
                    'insert-link': '',
                    'insert-image': '',
                    'insert-table': '',
                    'copy': '',
                    'cut': '',
                    'paste': '',
                    'bold': '',
                    'italic': '',
                    'underline': '',
                    'strikethrough': '',
                    'uppercase': '',
                    'lowercase': '',
                    'superscript': '',
                    'subscript': '',
                    'indents': '',
                    'outdents': '',
                    'html-source': '',
                    'full-screen': '',
                    'decrease-fontsize': '',
                    'increase-fontsize': '',
                    'justify-center': '',
                    'justify-full': '',
                    'justify-left': '',
                    'justify-right': '',
                    'clear-format': '',
                    'ordered-list': '',
                    'unordered-list': ''
                },
                rtePasteCleanupSettings: {
                    prompt: false,
                    plainText: true,
                    keepFormat: false
                },
                defaultSectionContextMenuItem: [
                    {
                        text: 'Insert New Section Before',
                        action: {
                            type: 'insert-before'
                        }
                    },
                    {
                        text: 'Insert New Section After',
                        action: {
                            type: 'insert-after'
                        }
                    }
                ],
                contextMenuItems: [],
                editorContentParentElement: null,
                currentSectionMode: 'insert',
                currentEditorSection: null,
                currentEditorSectionId: null,
                currentSpeakerSubSection: null,
                currentSpeakerSubSectionId: null,
                currentEditorRangeNode: null,
                currentEditorRangeOffset: null,
                currentEditorRangeCollapsed: false,
                currentEditorScrollPos: null,
                currentDialogInitOptions: null,
                configuration: null,
                configurationReady: false,
                dialogs: {
                    "turn": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Turn',
                            action: {
                                type: 'insert-section',
                                dialogName: 'turn'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Turn Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'turn'
                                }
                            },
                            {
                                text: 'Remove Turn Section',
                                action: {
                                    type: 'remove-section'
                                }
                            }
                        ]
                    },
                    "session": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Session',
                            action: {
                                type: 'insert-section',
                                dialogName: 'session'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Session Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'session'
                                }
                            },
                            {
                                text: 'Remove Session Section',
                                action: {
                                    type: 'remove-section'
                                }
                            }
                        ]
                    },
                    "speaker": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Speaker',
                            action: {
                                type: 'insert-section',
                                dialogName: 'speaker'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Speaker Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'speaker'
                                }
                            },
                            {
                                text: 'Remove Speaker Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                            {
                                text: 'Insert New Speaker Sub-Section',
                                action: {
                                    type: 'insert-speaker-subsection-at-start'
                                }
                            }
                        ]
                    },
                    "speakersubsection": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        contextMenuItems: [
                            {
                                text: 'Change Speaker Sub-Section Type',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'speakersubsection'
                                }
                            },
                            {
                                text: 'Remove Speaker Sub-Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },
                    "witnessstatus": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Witness Status',
                            action: {
                                type: 'insert-section',
                                dialogName: 'witnessstatus'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Witness Status Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'witnessstatus'
                                }
                            },
                            {
                                text: 'Remove Witness Status Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },
                    "witnessexamination": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Witness Mode',
                            action: {
                                type: 'insert-section',
                                dialogName: 'witnessexamination'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Witness Mode Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'witnessexamination'
                                }
                            },
                            {
                                text: 'Remove Witness Mode Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },
                    "event": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Court/Jury Event',
                            action: {
                                type: 'insert-section',
                                dialogName: 'event'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Court/Jury Event Section ',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'event'
                                }
                            },
                            {
                                text: 'Remove Court/Jury Event Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },
                    "miscevent": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Miscellaneous Event',
                            action: {
                                type: 'insert-section',
                                dialogName: 'miscevent'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Miscellaneous Event Section ',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'miscevent'
                                }
                            },
                            {
                                text: 'Remove Miscellaneous Event Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },
                    "exhibit": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Exhibit',
                            action: {
                                type: 'insert-section',
                                dialogName: 'exhibit'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Exhibit Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'exhibit'
                                }
                            },
                            {
                                text: 'Remove Exhibit Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },
                    "adjournment": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Adjournment',
                            action: {
                                type: 'insert-section',
                                dialogName: 'adjournment'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Adjournment Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'adjournment'
                                }
                            },
                            {
                                text: 'Remove Adjournment Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },
                    "interpreter": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Interpreter',
                            action: {
                                type: 'insert-section',
                                dialogName: 'interpreter'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Interpreter Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'interpreter'
                                }
                            },
                            {
                                text: 'Remove Interpreter Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },
                    "chargeandplea": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Arraignment',
                            action: {
                                type: 'insert-section',
                                dialogName: 'chargeandplea'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Arraignment Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'chargeandplea'
                                }
                            },
                            {
                                text: 'Remove Arraignment Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },
                    "retainingstyle": {
                        dialogOpen: false,
                        menuItem: {
                            text: 'Retaining Style',
                            action: {
                                type: 'insert-section',
                                dialogName: 'retainingstyle'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Retaining Style Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'retainingstyle'
                                }
                            },
                            {
                                text: 'Remove Retaining Style Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    },

                    "address": {
                        dialogConfiguration: null,
                        dialogOpen: false,
                        menuItem: {
                            text: 'Address',
                            action: {
                                type: 'insert-section',
                                dialogName: 'address'
                            }
                        },
                        contextMenuItems: [
                            {
                                text: 'Edit Address Section',
                                action: {
                                    type: 'edit-section',
                                    dialogName: 'address'
                                }
                            },
                            {
                                text: 'Remove Address Section',
                                action: {
                                    type: 'remove-section'
                                }
                            },
                        ]
                    }
                },

                documentContent: null,
                turnContent: null,
                wrapperIdBySectionId: null,
                performanceMode: false, //this.startWithPerformanceMode,
                colorMode: true,
                showAllNBSP: false,

                lastDraftSaveSuccessful: false,
                lastDraftSaveTime: null,
                saveDraftOnOrAfter: null,
                lastValidationTime: null,
                currentValidationMessages: null,
                showValidationMessages: false,
                showSourceModal: false,
                showAboutModal: false,
                showShortcutsModal: false,
                showImportModal: false,
                importFile: null,
                statusInfo: null,
                statusTimer: null,
                invalidSectionHighlightTimer: null,
                observer: null,
                observerActive: false,
                showProgressSpinner: false,

                newEditorFontFamily: null,
                newEditorFontSize: null,
                newDisplayMode: null,
                newColorMode: null,
                newPerformanceMode: null,
                newShowAllNBSP: null,

                speakerConsolidation: {
                    dialogOpen: false,
                    speakerSectionDetails: null
                },
            }
        },

        computed: {

            editorFontFace: function () {

                let fontFamily = this.editorFontFamily;
                if (this.showAllNBSP) {
                    fontFamily = `${this.editorFontFamily}-custom`; // Append "-Char" for modified font
                }
                return fontFamily;
            },

            filteredExpansions: function () {

                var filteredExpansionList = [];

                if (this.systemExpandables && this.systemExpandables.length) {

                    // to make sure that THIS referes to the component inside the forEachfilteredExpansions
                    var thisComponent = this;
                    this.systemExpandables.forEach(function (expansion) {

                        if (thisComponent.expansionFilter != '') {

                            if (expansion.short.toLowerCase().indexOf(thisComponent.expansionFilter.toLowerCase()) != -1 ||
                                expansion.long.toLowerCase().indexOf(thisComponent.expansionFilter.toLowerCase()) != -1) {
                                filteredExpansionList.push(expansion);
                            }
                        }
                        //else filteredExpansionList = thisComponent.systemExpandables;

                    });
                }
                return filteredExpansionList;
            },

            editorWrapperClass: function () {
                var cssClass = "w-100 h-100 d-flex flex-column align-items-stretch";
                if (this.colorMode) cssClass += " rte-color";
                if (this.displayMode == 'Portrait') cssClass += " rte-portrait";
                else if (this.displayMode == 'Landscape') cssClass += " rte-landscape";
                else cssClass += " rte-fullwidth";

                if (this.showAllNBSP) {
                    cssClass += ' rte-show-non-prt-chars';
                }

                return cssClass;
            },

            shortcutsForInfo: function () {
                let distinctShortcuts = [];
                if (this.configuration && this.configuration.shortcuts) {
                    this.configuration.shortcuts.forEach(shortcut => {
                        if (shortcut.separator || !distinctShortcuts.some(s => s.text == shortcut.text)) {
                            distinctShortcuts.push(shortcut);
                        }
                    });
                }
                return distinctShortcuts;
            },

            transcriptButtons: function () {
                let buttons = [];
                if (this.configuration) {
                    if (!this.readonly && this.configuration.availableDialogs) {
                        for (let dialogName in this.configuration.availableDialogs) {
                            if (this.configuration.availableDialogs[dialogName] && this.dialogs[dialogName].menuItem) {
                                let ribbonButtonSettings = {
                                    cssClass: "transcript-ribbon-button",
                                    content: this.dialogs[dialogName].menuItem.text + this.getDialogShortCut(this.dialogs[dialogName].menuItem.action.dialogName),
                                    clicked: () => {
                                        this.onAction(this.dialogs[dialogName].menuItem.action);
                                    }
                                };
                                buttons.push(ribbonButtonSettings);
                            }
                        }
                    }
                }
                return buttons;
            },
            mainMenuItems: function () {
                var menuItems = [];
                if (this.configuration) {
                    if (this.readonly && this.configuration.readOnlyMenuItems) menuItems = this.configuration.readOnlyMenuItems;
                    else if (this.configuration.defaultMenuItems) menuItems = this.configuration.defaultMenuItems;
                    if (!this.readonly && this.configuration.availableDialogs) {
                        for (var dialogName in this.configuration.availableDialogs) {
                            if (this.configuration.availableDialogs[dialogName] && this.dialogs[dialogName].menuItem) {
                                menuItems[1].items.push(this.dialogs[dialogName].menuItem);
                            }
                        }
                    }
                    if (this.configuration.development && this.configuration.developmentMenuItems) {
                        this.configuration.developmentMenuItems.forEach((menuItem) => {
                            menuItems.push(menuItem);
                        })
                    }
                }
                return menuItems;
            },
            autosaveInterval: function () {
                if ((this.configuration == null) || (this.configuration.autosaveInterval == null)) {
                    return 5000; //5 seconds
                }
                return this.configuration.autosaveInterval;
            },
            dialogOpen: function () {
                for (var dialogName in this.dialogs) {
                    if (this.dialogs[dialogName].dialogOpen) return true;
                }
                return false;
            },
            currentValidationStatus: function () {
                var validationStatus = '<i class="fas fa-info-circle my-2"></i>';
                if (this.lastValidationTime != null) {
                    if ((this.currentValidationMessages == null) || (this.currentValidationMessages.length == 0)) {
                        validationStatus = '<i class="fas fa-check-circle mr-2 my-2 text-success"></i>No validation errors';
                    } else if (this.currentValidationMessages.length == 1) {
                        validationStatus = '<i class="fas fa-times-circle mr-2 my-2 text-danger"></i>1 validation error';
                    } else {
                        validationStatus = '<i class="fas fa-times-circle mr-2 my-2 text-danger"></i>' + this.currentValidationMessages.length + ' validation errors';
                    }
                    validationStatus += ' (validated at ' + this.formatDateTime(this.lastValidationTime, 'h:mm:ssa') + ')';
                }
                return validationStatus;
            },
            currentDraftVersionStatus: function () {
                var draftVersionStatus = '';
                if (this.lastDraftSaveTime != null) {
                    if (this.lastDraftSaveSuccessful) {
                        draftVersionStatus = 'Draft saved successfully at ' + this.formatDateTime(this.lastDraftSaveTime, 'h:mm:ssa') + '<i class="fas fa-check-circle m-2 text-success"></i>';
                    } else {
                        draftVersionStatus = 'Draft failed to save at ' + this.formatDateTime(this.lastDraftSaveTime, 'h:mm:ssa') + '<i class="fas fa-times-circle m-2 text-danger"></i>';
                    }
                }
                return draftVersionStatus;
            },
            showStatusErrorModal: function () {
                if (this.statusInfo && this.statusInfo.status != 'ok') return true;
                return false;
            },

            editorFontSizeInPx: function () {
                return this.editorFontSize + 'px';
            }
        },

        methods: {

            checkSectionContent: function (sectionContent) {
                if (sectionContent == null || sectionContent.trim() == '') return null
                else return sectionContent;
            },

            topscribeDocumentIndexShown: function () {
                this.buildTopscribeIndex();
            },

            buildTopscribeIndex: function () {

                this.topscribeSectionList = [];
                var thisComponent = this;

                // Define a node filter to match elements with data-sub-type="nbhy"
                const filter = {
                    acceptNode: function (node) {
                        if (node.nodeType === Node.ELEMENT_NODE && (node.getAttribute("data-type") === "turn" ||
                            (thisComponent.selectedTopscribeIndexOptions.includes(node.getAttribute("data-type"))
                            )))
                        {
                            return NodeFilter.FILTER_ACCEPT;
                        }
                        return NodeFilter.FILTER_SKIP;
                    }
                };

                // Create a TreeWalker to traverse the document body
                const treeWalker = document.createTreeWalker(
                    document.getElementById('richTextEditorId_rte-edit-view'),                 // Root node
                    NodeFilter.SHOW_ELEMENT,      // Only show element nodes
                    filter,                        // Custom filter
                    false
                );

                // Use the TreeWalker to find matching nodes
                this.topscribeSectionList = [];
                let currentNode = treeWalker.nextNode();
                while (currentNode) {
                    
                    var sectionObj = {};
                    sectionObj.sectionId = currentNode.getAttribute('id');
                    sectionObj.dataType = currentNode.getAttribute('data-type');

                    if (sectionObj.dataType == 'speaker') sectionObj.dataContent = currentNode.getAttribute('data-margintext')
                    else sectionObj.dataContent = currentNode.getAttribute('data-content');

                    this.topscribeSectionList.push(sectionObj);
                    currentNode = treeWalker.nextNode();
                }
            },

            resetFindAndReplaceUI: function () {
                this.searchResults = [];
                this.searchResultsList = [];
                this.showFindAndReplaceAlert = false;
            },

            findAndReplaceSideBarShown: function () {
                this.$refs.searchFor.focus();
                this.buildTopscribeIndex();
            },

            findMatches: function (node, regexp, documentSectionId, positions) {

                var allResults = []; // matching

                if (node.nodeName == '#text') {

                    // find the closest parent node containing an id='9e885c25-6f75-4de6-b4dd-5eac0557b153'
                    // when clicking on a search result this will be the ID used to scroll into view
                    // instead of the documentSectionID (root sections can be longer than one page)
                    // the leafSectionId is much more granular

                    // step back to parent and check if an ID is present
                    var parent = node.parentNode;
                    while (parent.id == '') {
                        parent = parent.parentNode;
                    }
                    var leafSectionId = parent.id;

                    var matches = node.textContent.matchAll(regexp);

                    for (const match of matches) {
                        var obj = {};
                        obj.positions = positions;
                        obj.match = match[0];

                        obj.displayText = match.input.substring(match.index - 10, match.index + match[0].length + 10);
                        obj.displayText = '... ' + obj.displayText.replace(obj.match, '<b>' + obj.match + '</b>') + ' ...';

                        // this is the section ID of root sections
                        obj.documentSectionId = documentSectionId;
                        // this is closest parent node containing a valid ID, like id='9e885c25-6f75-4de6-b4dd-5eac0557b153'
                        obj.leafSectionId = leafSectionId;
                        obj.sectionOffset = match.index;

                        allResults.push(obj);
                        // console.log(`Found ${match[0]} start=${match.index} end=${match.index + match[0].length}.`);
                        // console.log(obj);
                    }

                } else if (node.childNodes) {

                    for (var j = 0; j < node.childNodes.length; j++) {
                        var childNode = node.childNodes[j];
                        // clone the array
                        var newPositions = positions.slice();
                        newPositions.push(j);

                        var results = this.findMatches(childNode, regexp, documentSectionId, newPositions);
                        results.forEach(result => allResults.push(result));
                    }
                }
                return allResults;
            },

            findMatchesInSpeakerSections: function (regex) {

                var searchResults = [];
                var section = null;
                var dataType = '';
                var matches = [];

                var sectionNodes = this.editorContentParentElement.children;

                for (var i = 0; i < sectionNodes.length; i++) {
                    section = sectionNodes[i];
                    dataType = section.getAttribute('data-type');

                    if (dataType == 'speaker') {
                        matches = this.findMatches(section, regex, section.getAttribute('id'), []);
                        searchResults = searchResults.concat(matches);
                    }
                }
                return searchResults;

            },

            findAndReplaceHandler: function (mode) {

                var pattern = this.searchFor;

                if (this.selectedFindAndReplaceOptions.includes('whole-word-only'))
                    pattern = "\\b" + this.searchFor + "\\b";

                var flags = "gi"; // 'g': globla 'i': ignore case
                if (this.selectedFindAndReplaceOptions.includes('match-case')) flags = "g"

                var regex = new RegExp(pattern, flags);

                switch (mode) {
                    case 'find':

                        if (this.searchResults.length == 0) {
                            this.searchResultsList = [];
                            this.searchResultsCounter = 0;
                            this.searchResults = this.findMatchesInSpeakerSections(regex);
                        }
                        this.searchResultItemClicked(this.searchResults[this.searchResultsCounter]);
                        this.searchResultsCounter = (this.searchResultsCounter + 1) % this.searchResults.length;

                        break;

                    case 'find-all':
                        // this counter is used to iterate over result with the FIND button
                        this.searchResultsCounter = 0;
                        this.searchResults = this.findMatchesInSpeakerSections(regex);
                        // shows results as a clickable list in the the search panel
                        if (this.searchResults.length)
                            this.findAndReplaceAlertDisplayText = this.searchResults.length + '  results found'
                        else
                            this.findAndReplaceAlertDisplayText = 'No occurrences found'

                        this.showFindAndReplaceAlert = true;
                        this.searchResultsList = this.searchResults;
                        this.searchResult = [];
                        break;

                    case 'replace-all':

                        this.searchResultsCounter = 0;
                        this.searchResults = this.findMatchesInSpeakerSections(regex);

                        if (this.searchResults.length == 0) {
                            this.findAndReplaceAlertDisplayText = 'No occurrences found';
                            this.showFindAndReplaceAlert = true;
                            return;
                        }

                        // get the user to confirm if they want to OVERWRITE or abandon
                        this.$bvModal.msgBoxConfirm('Do you want to replace ' + this.searchResults.length + ' occurences of [' + this.searchFor + '] with [' + this.replaceWith + '] ?', {
                            title: 'Please Confirm',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            okTitle: 'YES',
                            cancelTitle: 'NO',
                            footerClass: 'p-2',
                            centered: true,
                            hideHeaderClose: true,

                        })
                            .then(value => {
                                if (value) {
                                    this.replaceAllMatches(regex, this.searchResults);
                                    this.findAndReplaceAlertDisplayText = this.searchResults.length + '  occurrences were replaced with: ' + this.replaceWith;
                                    this.showFindAndReplaceAlert = true;
                                    this.searchResultsList = [];
                                }
                            })
                        break;

                    default:
                        console.log('no valid mode');
                }
            },

            replaceAllMatches: function (regex, searchResults) {

                searchResults.forEach(searchResultObj => {

                    if (searchResultObj.documentSectionId) {

                        var mainDiv = document.getElementById(searchResultObj.documentSectionId);
                        var positions = searchResultObj.positions;
                        var myNode = mainDiv.childNodes[positions[0]];

                        for (var pos = 1; pos < searchResultObj.positions.length; pos++) {
                            myNode = myNode.childNodes[positions[pos]];
                        }

                        // investigate replaceAll with regex ... otherwise ranges from the back.
                        // make use of the flags

                        var oldText = myNode.nodeValue;
                        //var newText = oldText.replaceAll(this.searchFor, this.replaceWith,);
                        var newText = oldText.replaceAll(regex, this.replaceWith,);
                        myNode.nodeValue = newText;
                    } else {
                        console.log('missing section id during replace all');
                    }
                });
            },

            topscribeIndexClicked: function (sectionObj) {

                var section = $('#' + sectionObj.sectionId);
                this.scrollIntoView(section[0], null, true);

            },


            searchResultItemClicked: function (searchResultObj) {

                if (searchResultObj.documentSectionId) {

                    //if (this.performanceMode) {
                    //    if (this.wrapperIdBySectionId && this.wrapperIdBySectionId[validationMessage.documentSectionId]) {
                    //        var wrapperId = this.wrapperIdBySectionId[validationMessage.documentSectionId];
                    //        var wrapperSection = $('#' + wrapperId);
                    //        if ((wrapperSection.length == 1) && (wrapperSection[0].getAttribute('data-cleared') == 'true')) {
                    //            wrapperSection[0].innerHTML = this.turnContent[wrapperId];
                    //            wrapperSection[0].removeAttribute('style');
                    //            wrapperSection[0].removeAttribute('data-cleared');
                    //        }
                    //    }
                    //}

                    var leaf = $('#' + searchResultObj.leafSectionId);
                    this.scrollIntoView(leaf[0], null, true);

                    var mainDiv = document.getElementById(searchResultObj.documentSectionId);

                    var positions = searchResultObj.positions;
                    var startNode = mainDiv.childNodes[positions[0]];

                    for (var pos = 1; pos < searchResultObj.positions.length; pos++) {
                        startNode = startNode.childNodes[positions[pos]];
                    }

                    var endNode = startNode; // in general we should always have to search in the same 'container'

                    // working version
                    //var startNode = mainDiv.childNodes[0];
                    //startNode = startNode.childNodes[0];
                    //startNode = startNode.childNodes[0];
                    // also a working version
                    // var endNode = mainDiv.firstChild.firstChild.firstChild;

                    //console.log('START NODE: ' + startNode);
                    //console.log('END NODE: ' + endNode);

                    var range = document.createRange();
                    range.setStart(startNode, searchResultObj.sectionOffset);
                    range.setEnd(endNode, searchResultObj.sectionOffset + searchResultObj.match.length);

                    var sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            },

            onNewParagraph: function () {
                if (this.editorContentParentElement) {
                    var currentEditorRange = this.$refs.topscribeEditor.getRange();
                    if (currentEditorRange) {
                        var currentElement = currentEditorRange.endContainer;
                        if (currentElement) {
                            var scrollIntoView = true;
                            var currentParagraph = null;
                            var currentSpeakerSubSection = null;
                            while ((currentSpeakerSubSection == null) &&
                                (currentElement != this.editorContentParentElement) &&
                                (typeof (currentElement.parentNode) != "undefined") &&
                                (currentElement.parentNode != null) &&
                                (currentElement.parentNode != this.editorContentParentElement) &&
                                ($(currentElement.parentNode).data('type') != 'turnwrapper')) {
                                if ((currentParagraph == null) && ((currentElement.tagName == 'P') || (currentElement.tagName == 'p'))) {
                                    currentParagraph = currentElement;
                                }
                                if ($(currentElement).data('type') == 'speaker-subsection') {
                                    currentSpeakerSubSection = currentElement;
                                }
                                currentElement = currentElement.parentNode;
                            }
                            if (currentSpeakerSubSection && currentParagraph) {
                                if (currentParagraph.innerText.replaceAll('\r\n', '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('&nbsp;', '').trim() == '') {
                                    //the current paragraph is a new and empty one
                                    var nextParagraph = $(currentParagraph).next();
                                    if (nextParagraph.length == 0) {
                                        //and it is the last in that speaker sub section
                                        var speakerSubSectionType = $(currentSpeakerSubSection).data('sub-type');
                                        if ((speakerSubSectionType == 'answer') ||
                                            (speakerSubSectionType == 'answer-witness') ||
                                            (speakerSubSectionType == 'answer-interpreter') ||
                                            (speakerSubSectionType == 'answer-examinee')) {
                                            $(currentParagraph).remove();
                                            this.insertSpeakerSubSection('statement');
                                            scrollIntoView = false;
                                        }
                                    }
                                }
                            }
                            if (scrollIntoView && currentParagraph) {
                                this.scrollIntoView(currentParagraph, null, true);
                            }
                        }
                    }
                }
            },

            handleBackspaceOrDeleteKey: function (e) {
                if (this.dialogOpen || this.expansionManagerActive || this.findAndReplaceInUse || this.showQuickCheckModal) {
                    return;
                }
                if (((e.key != 'Backspace') && (e.key != 'Delete')) || e.altKey || e.metaKey || e.shiftKey) {
                    return;
                }
                this.storeCurrentEditorSelection();
                if (this.currentEditorSection != null) {
                    var currentDataType = $(this.currentEditorSection).data('type');
                    if ((currentDataType == "speaker") || (currentDataType == "retainingstyle")) {
                        var currentNode = null;
                        var currentNodeDataType = null;
                        var stopEventHandling = false;
                        var nodesMerged = false;
                        var currentNodeIsEmpty = false;
                        if (e.key == 'Backspace') {
                            if ((this.currentEditorRangeOffset == 0) &&
                                this.currentEditorRangeCollapsed) {
                                stopEventHandling = true;
                                currentNode = this.currentEditorRangeNode;
                                var previousNode = null;
                                var previousNodeIsEmpty = false;
                                var previousNodeLastChild = null;
                                //first, could be that we are in a text node and there is a previous text node - if so, we merge them
                                if (currentNode.nodeName == "#text") {
                                    previousNode = currentNode.previousSibling;
                                    if (previousNode && (previousNode.nodeName == "#text")) {
                                        this.currentEditorRangeNode = previousNode;
                                        this.currentEditorRangeOffset = previousNode.textContent.length - 1;
                                        previousNode.textContent = previousNode.textContent.substring(0, previousNode.textContent.length - 1) + currentNode.textContent;
                                        $(currentNode).remove();
                                        nodesMerged = true;
                                        this.restoreEditorSelection();
                                    } else if (!previousNode) {
                                        if (currentNode.parentNode &&
                                            (currentNode.parentNode.firstChild == currentNode)) {
                                            currentNode = currentNode.parentNode;
                                            if (currentNode.nodeName != "P") {
                                                //we are most likely in a style section, lets try to find the next paragraph
                                                while ((currentNode.nodeName != "P") &&
                                                    currentNode.parentNode &&
                                                    (currentNode.parentNode.firstChild == currentNode)) {
                                                    currentNode = currentNode.parentNode;
                                                }
                                                if (currentNode.nodeName != "P") {
                                                    //we did not find a paragraph where our text is the first child
                                                    stopEventHandling = false;
                                                }
                                            }
                                        } else {
                                            stopEventHandling = false;
                                        }
                                    } else {
                                        stopEventHandling = false;
                                    }
                                }
                                //second, we check whether we are in a paragraph and there is a previous one - if so we merge them
                                if (!nodesMerged && (currentNode.nodeName == "P")) {
                                    previousNode = currentNode.previousSibling;
                                    if (previousNode && (previousNode.nodeName == "P")) {
                                        previousNodeLastChild = previousNode.lastChild;
                                        //we only append the current node to the previous one if the current one is not just a line placeholder, i.e. a P tag with just a BR
                                        if ((currentNode.childNodes.length == 1) &&
                                            (currentNode.childNodes[0].nodeName == "BR")) {
                                            currentNodeIsEmpty = true;
                                        }
                                        //we only append the current node to the previous one if the previous one is not just a line placeholder, i.e. a P tag with just a BR
                                        if ((previousNode.childNodes.length == 1) &&
                                            (previousNode.childNodes[0].nodeName == "BR")) {
                                            previousNodeIsEmpty = true;
                                        }
                                        if (!currentNodeIsEmpty && !previousNodeIsEmpty) {
                                            $(previousNode).append($(currentNode).html())
                                            $(currentNode).remove();
                                        } else if (!previousNodeIsEmpty) {
                                            $(currentNode).remove();
                                        } else {
                                            $(previousNode).remove();
                                            previousNodeLastChild = null;
                                        }
                                        nodesMerged = true;
                                        if (previousNodeLastChild) {
                                            if (previousNodeLastChild.nextSibling) {
                                                this.currentEditorRangeNode = previousNodeLastChild.nextSibling;
                                            } else {
                                                this.currentEditorRangeNode = previousNodeLastChild;
                                                if (previousNodeLastChild.nodeName == "#text") {
                                                    this.currentEditorRangeOffset = previousNodeLastChild.textContent.length;
                                                } else {
                                                    this.currentEditorRangeOffset = previousNodeLastChild.childNodes.length;
                                                }
                                            }
                                            this.restoreEditorSelection();
                                        }
                                    } else if (!previousNode) {
                                        if (currentNode.parentNode &&
                                            (currentNode.parentNode.firstChild == currentNode)) {
                                            currentNode = currentNode.parentNode;
                                        }
                                    }
                                }
                                //finally, we are in a speaker sub-section and there is a previous speaker sub-section - if so we merge them
                                if (!nodesMerged && (currentNode.nodeName == "DIV")) {
                                    currentNodeDataType = $(currentNode).data('type');
                                    if (currentNodeDataType == "speaker-subsection") {
                                        previousNode = currentNode.previousSibling;
                                        if (previousNode && (previousNode.nodeName == "DIV") && ($(previousNode).data('type') == "speaker-subsection")) {
                                            previousNodeLastChild = previousNode.lastChild;
                                            //we only append the current node to the previous one if the current one is not just a line placeholder, i.e. a DIV tag with a single P tag with just a BR
                                            if ((currentNode.childNodes.length == 1) &&
                                                (currentNode.childNodes[0].nodeName == "P") &&
                                                (currentNode.childNodes[0].childNodes.length == 1) &&
                                                (currentNode.childNodes[0].childNodes[0].nodeName == "BR")) {
                                                currentNodeIsEmpty = true;
                                            }
                                            //we only append the current node to the previous one if the previous one is not just a line placeholder, i.e. a DIV tag with a single P tag with just a BR
                                            if ((previousNode.childNodes.length == 1) &&
                                                (previousNode.childNodes[0].nodeName == "P") &&
                                                (previousNode.childNodes[0].childNodes.length == 1) &&
                                                (previousNode.childNodes[0].childNodes[0].nodeName == "BR")) {
                                                previousNodeIsEmpty = true;
                                            }
                                            if (!currentNodeIsEmpty && !previousNodeIsEmpty) {
                                                $(previousNode).append($(currentNode).html())
                                                $(currentNode).remove();
                                            } else if (!previousNodeIsEmpty) {
                                                $(currentNode).remove();
                                            } else {
                                                $(previousNode).remove();
                                                previousNodeLastChild = null;
                                            }
                                            nodesMerged = true;
                                            if (previousNodeLastChild) {
                                                if (previousNodeLastChild.nextSibling) {
                                                    this.currentEditorRangeNode = previousNodeLastChild.nextSibling;
                                                } else {
                                                    this.currentEditorRangeNode = previousNodeLastChild;
                                                    if (previousNodeLastChild.nodeName == "#text") {
                                                        this.currentEditorRangeOffset = previousNodeLastChild.textContent.length;
                                                    } else {
                                                        this.currentEditorRangeOffset = previousNodeLastChild.childNodes.length;
                                                    }
                                                }
                                                this.restoreEditorSelection();
                                            }
                                        }
                                    } else if ((currentNodeDataType == null) || (currentNodeDataType == "")) {
                                        stopEventHandling = false;
                                    }
                                } else if (!nodesMerged) {
                                    stopEventHandling = false;
                                }
                            }
                        } else if (e.key == 'Delete') {
                            if (this.currentEditorRangeCollapsed) {
                                var isAtEnd = false;
                                currentNode = this.currentEditorRangeNode;
                                if ((currentNode.nodeName == "#text") &&
                                    (this.currentEditorRangeOffset == currentNode.textContent.length)) {
                                    isAtEnd = true;
                                } else if ((currentNode.nodeName != "P") &&
                                    currentNode.childNodes &&
                                    (this.currentEditorRangeOffset == currentNode.childNodes.length) &&
                                    currentNode.parentNode &&
                                    (currentNode.parentNode.lastChild == currentNode)) {
                                    isAtEnd = true;
                                    currentNode = currentNode.parentNode;
                                } else if ((currentNode.nodeName == "P") &&
                                    currentNode.childNodes &&
                                    (this.currentEditorRangeOffset == currentNode.childNodes.length)) {
                                    isAtEnd = true;
                                } else if ((currentNode.nodeName == "P") &&
                                    currentNode.childNodes &&
                                    (this.currentEditorRangeOffset == (currentNode.childNodes.length - 1)) &&
                                    (currentNode.lastChild.nodeName == 'BR')) {
                                    isAtEnd = true;
                                }
                                if (isAtEnd) {
                                    stopEventHandling = true;
                                    var nextNode = null;
                                    var nextNodeIsEmpty = false;
                                    //first, could be that we are in a text node and there is a next text or br node - if so, we merge them
                                    if (currentNode.nodeName == "#text") {
                                        nextNode = currentNode.nextSibling;
                                        if (nextNode && (nextNode.nodeName == "#text")) {
                                            currentNode.textContent += nextNode.textContent.substring(1);
                                            $(nextNode).remove();
                                            nodesMerged = true;
                                        } else if (nextNode && (nextNode.nodeName == "BR")) {
                                            $(nextNode).remove();
                                            nodesMerged = true;
                                        } else if (!nextNode) {
                                            if (currentNode.parentNode &&
                                                (currentNode.parentNode.lastChild == currentNode)) {
                                                currentNode = currentNode.parentNode;
                                                if (currentNode.nodeName != "P") {
                                                    //we are most likely in a style section, lets try to find the next paragraph
                                                    while ((currentNode.nodeName != "P") &&
                                                        currentNode.parentNode &&
                                                        (currentNode.parentNode.lastChild == currentNode)) {
                                                        currentNode = currentNode.parentNode;
                                                    }
                                                    if (currentNode.nodeName != "P") {
                                                        //we did not find a paragraph where our text is the last child
                                                        stopEventHandling = false;
                                                    }
                                                }
                                            } else {
                                                stopEventHandling = false;
                                            }
                                        } else {
                                            stopEventHandling = false;
                                        }
                                    }
                                    //second, we check whether we are in a paragraph and there is a previous one - if so we merge them
                                    if (!nodesMerged && (currentNode.nodeName == "P")) {
                                        nextNode = currentNode.nextSibling;
                                        if (nextNode && (nextNode.nodeName == "P")) {
                                            //we only merge the current node with the next one if the current one is not just a line placeholder, i.e. a P tag with just a BR
                                            if ((currentNode.childNodes.length == 1) &&
                                                (currentNode.childNodes[0].nodeName == "BR")) {
                                                currentNodeIsEmpty = true;
                                            }
                                            //we only merge the current node with the next one if the next one is not just a line placeholder, i.e. a P tag with just a BR
                                            if ((nextNode.childNodes.length == 1) &&
                                                (nextNode.childNodes[0].nodeName == "BR")) {
                                                nextNodeIsEmpty = true;
                                            }
                                            if (!currentNodeIsEmpty && !nextNodeIsEmpty) {
                                                $(currentNode).append($(nextNode).html())
                                                $(nextNode).remove();
                                            } else if (!nextNodeIsEmpty) {
                                                $(currentNode).remove();
                                                if (nextNode.firstChild) {
                                                    this.currentEditorRangeNode = nextNode.firstChild;
                                                    this.currentEditorRangeOffset = 0;
                                                    this.restoreEditorSelection();
                                                }
                                            } else {
                                                $(nextNode).remove();
                                            }
                                            nodesMerged = true;
                                        } else if (!nextNode) {
                                            if (currentNode.parentNode &&
                                                (currentNode.parentNode.lastChild == currentNode)) {
                                                currentNode = currentNode.parentNode;
                                            }
                                        }
                                    }
                                    //finally, we are in a speaker sub-section and there is a new speaker sub-section - if so we merge them
                                    if (!nodesMerged && (currentNode.nodeName == "DIV")) {
                                        currentNodeDataType = $(currentNode).data('type');
                                        if (currentNodeDataType == "speaker-subsection") {
                                            nextNode = currentNode.nextSibling;
                                            if (nextNode && (nextNode.nodeName == "DIV") && ($(nextNode).data('type') == "speaker-subsection")) {
                                                //we only merge the current node with the next one if the current one is not just a line placeholder, i.e. a DIV tag with a single P tag with just a BR
                                                if ((currentNode.childNodes.length == 1) &&
                                                    (currentNode.childNodes[0].nodeName == "P") &&
                                                    (currentNode.childNodes[0].childNodes.length == 1) &&
                                                    (currentNode.childNodes[0].childNodes[0].nodeName == "BR")) {
                                                    currentNodeIsEmpty = true;
                                                }
                                                //we only merge the current node with the next one if the next one is not just a line placeholder, i.e. a DIV tag with a single P tag with just a BR
                                                if ((nextNode.childNodes.length == 1) &&
                                                    (nextNode.childNodes[0].nodeName == "P") &&
                                                    (nextNode.childNodes[0].childNodes.length == 1) &&
                                                    (nextNode.childNodes[0].childNodes[0].nodeName == "BR")) {
                                                    nextNodeIsEmpty = true;
                                                }
                                                if (!currentNodeIsEmpty && !nextNodeIsEmpty) {
                                                    $(currentNode).append($(nextNode).html())
                                                    $(nextNode).remove();
                                                } else if (!nextNodeIsEmpty) {
                                                    $(currentNode).remove();
                                                    if (nextNode.firstChild) {
                                                        this.currentEditorRangeNode = nextNode.firstChild;
                                                        this.currentEditorRangeOffset = 0;
                                                        this.restoreEditorSelection();
                                                    }
                                                } else {
                                                    $(nextNode).remove();
                                                }
                                                nodesMerged = true;
                                            }
                                        } else if ((currentNodeDataType == null) || (currentNodeDataType == "")) {
                                            stopEventHandling = false;
                                        }
                                    } else if (!nodesMerged) {
                                        stopEventHandling = false;
                                    }
                                }
                            }
                        }
                        if (stopEventHandling) {
                            e.preventDefault(); //this will stop the backspace handling completedly!
                            e.stopImmediatePropagation(); //this will fix the issue that in chrome/edge the tags structure gets messed up
                        }
                    } else if ((currentDataType == "address") ||
                        (currentDataType == "adjournment") ||
                        (currentDataType == "chargeandplea") ||
                        (currentDataType == "event") ||
                        (currentDataType == "exhibit") ||
                        (currentDataType == "interpreter") ||
                        (currentDataType == "miscevent") ||
                        (currentDataType == "session") ||
                        (currentDataType == "turn") ||
                        (currentDataType == "witness")) {
                        e.preventDefault(); //this will stop the backspace handling completedly!
                        e.stopImmediatePropagation(); //this will fix the issue that in chrome/edge the tags structure gets messed up
                        this.$bvToast.toast('This action is only valid in a speaker or retaining style section', {
                            title: 'Invalid Action',
                            variant: 'danger',
                            appendToast: true
                        });
                    }
                }
                this.resetCurrentEditorSelection();
            },

            peserveCurrentEditorPosition: function () {
                this.storeCurrentEditorSelection(null, false);
            },

            restoreCurrenEditPosition: function () {
                this.restoreEditorSelection();
                this.resetCurrentEditorSelection();
                this.focusEditor();
            },

            updateModelsWithCurrentValues: function () {
                this.storeCurrentEditorSelection(null, false);
                this.newEditorFontFamily = this.editorFontFamily;
                this.newEditorFontSize = this.editorFontSize;
                this.newDisplayMode = this.displayMode;
                this.newColorMode = this.colorMode;
                this.newPerformanceMode = this.performanceMode;
                this.newShowAllNBSP = this.showAllNBSP;
            },

            updateAllEditorSetting: function () {
                // props from the settings modal

                this.editorFontFamily = this.newEditorFontFamily;

                this.editorFontSize = this.newEditorFontSize;
                this.displayMode = this.newDisplayMode;
                //this.performanceMode = this.newPerformanceMode;

                this.colorMode = this.newColorMode;
                this.showAllNBSP = this.newShowAllNBSP;
                this.saveEditorSettings();
            },

            saveEditorSettings: function () {
                var editorSettings = {
                    editorFontFamily: this.editorFontFamily,
                    editorFontSize: this.editorFontSize,
                    displayMode: this.displayMode,
                    performanceMode: this.performanceMode,
                    colorMode: this.colorMode,
                    showAllNBSP: this.showAllNBSP
                }
                localStorage.setItem('editorSettings', JSON.stringify(editorSettings));
            },

            restoreEditorSettings: function () {
                var editorSettings = JSON.parse(localStorage.getItem('editorSettings'));
                if (editorSettings) {
                    this.editorFontFamily = editorSettings.editorFontFamily
                    this.editorFontSize = editorSettings.editorFontSize
                    this.displayMode = editorSettings.displayMode
                    //this.performanceMode = editorSettings.performanceMode
                    this.colorMode = editorSettings.colorMode
                    this.showAllNBSP = editorSettings.showAllNBSP
                }
            },

            sanitizeExpansionShort: function (event) {
                const keyCode = event.keyCode;
                // (space)
                if (keyCode == 32) event.preventDefault();
            },

            focusOnQuickAddLongInput: function () {
                this.$refs.quickAddLongInput.focus();
            },
            focusOnQuickAddButton: function () {
                this.$refs.quickAddButton.focus();
            },
            glossaryShown: function () {
                this.$refs.glossaryLookupInput.focus();
            },
            shortcutsSideBarShown: function () {

            },
            transcriptionSideBarShown: function () {

            },
            quickAddModalShown: function () {
                this.$refs.quickAddShortInput.focus();
            },
            getDialogShortCut: function (dialogName) {
                let obj = this.configuration.shortcuts.find(o => o.action?.dialogName === dialogName);
                if (obj == null) return '';
                return ' ' + obj.text;
            },

            undoLastExpansions: function (args) {
                if (this.lastUsedExpansion) { //we do have a last used expansion that we can undo
                    var selection = this.$refs.topscribeEditor.getRange();
                    if (selection && selection.collapsed) { //only if we find the cursor position and there is no actual selection (i.e. start and end pos are the same, i.e. collapsed)
                        //first check whether the text just before the cursor is the last used expansions long version
                        var expandedLength = this.lastUsedExpansion.long.length;
                        var endOffset = selection.endOffset - 1; //the expanded text ends one character before the current cursor pos, cause of the character that triggered the expansion
                        var startOffset = endOffset - expandedLength;
                        if (startOffset >= 0) {
                            var allText = selection.endContainer.textContent;
                            var relevantText = allText.substr(startOffset, expandedLength);
                            if (relevantText == this.lastUsedExpansion.long) { //the text just before the cursor matches the expansion
                                var triggerChar = allText.substr(endOffset, 1); //the character just after the expanded text is the trigger character
                                var range = document.createRange();
                                range.setStart(selection.endContainer, startOffset);
                                range.setEnd(selection.endContainer, endOffset + 1); //include the trigger character

                                this.$refs.topscribeEditor.selectRange(range); //and select it
                                this.rteSaveUndoData();
                                this.$refs.topscribeEditor.executeCommand('insertText', this.lastUsedExpansion.short + triggerChar); //then replace the expanded text with original string (plus the trigger character)
                                //and finally position the cursor after the inserted text

                                var selection2 = this.$refs.topscribeEditor.getRange()
                                range = document.createRange();
                                range.setStart(selection2.endContainer, selection2.endOffset);
                                this.$refs.topscribeEditor.selectRange(range);
                                args.event.preventDefault();
                            }
                        }
                    }
                }
                this.lastUsedExpansion = null;
            },

            findRecentlyTypedWord: function (minWordLength = 2) {
                var selection = this.$refs.topscribeEditor.getRange();
                if (selection && selection.collapsed) { //only if we find the cursor position and there is no actual selection (i.e. start and end pos are the same, i.e. collapsed)
                    var allText = selection.endContainer.textContent; //get the text content of the current text node
                    var endOfWordIndex = selection.endOffset;
                    var relevantText = allText.substr(0, selection.endOffset); //text prior to cursor position
                    var startOfWordIndex = relevantText.lastIndexOf(" ");
                    if (startOfWordIndex < 0) {
                        startOfWordIndex = 0;
                    } else {
                        startOfWordIndex = startOfWordIndex + 1;
                    }
                    if ((endOfWordIndex - startOfWordIndex) >= minWordLength) {
                        var word = relevantText.substr(startOfWordIndex, endOfWordIndex - startOfWordIndex);
                        return {
                            word: word,
                            startIndex: startOfWordIndex,
                            endIndex: endOfWordIndex,
                            length: endOfWordIndex - startOfWordIndex,
                            container: selection.endContainer
                        };
                    }
                }
                return null;
            },

            writeLastUsedExpansionToLocalStorage: function (lastUsedExpansion) {

                var expandablesModification = JSON.parse(localStorage.getItem('systemExpandablesModifications'));
                // this is the UUID of the last used/expanded expansions
                var index = expandablesModification.findIndex(element => element.uuid === lastUsedExpansion.uuid);

                if (index >= 0) {
                    expandablesModification.splice(index, 1);
                }

                lastUsedExpansion.lastUsed = new Date();
                lastUsedExpansion.modification = 'modified';

                expandablesModification.push(lastUsedExpansion);
                localStorage.setItem('systemExpandablesModifications', JSON.stringify(expandablesModification));

            },

            checkForExpansion: function () {
                if (this.systemExpandables == null) return;
                var recentlyTypedWord = this.findRecentlyTypedWord();
                if (!recentlyTypedWord) return;

                // first char ...
                var lookUpCharacter = recentlyTypedWord.word.charAt(0);
                // array of expansions starting with lookUpCharacter
                var characterNodeExpansions = this.systemExpandablesLookup[lookUpCharacter.toLowerCase()];
                // if we cant find an expansions node for the CHAR given ... go back ... nothing to see
                if (!characterNodeExpansions) return;
                // now check if we find the abbreviation in this subset of expansions
                var index = characterNodeExpansions.findIndex(x => x.short == recentlyTypedWord.word.toLowerCase());

                // lookup found in list of exapansions
                if (index != -1) {

                    var expandedText = characterNodeExpansions[index]['long'];

                    // Simple smart casing for now:
                    // if first char of abbreviation is UPPER ==> make first char of long UPPER
                    // regardless of matching chars or matching word count

                    var fistCharOfAbbreviation = recentlyTypedWord.word.charAt(0);
                    if (fistCharOfAbbreviation == fistCharOfAbbreviation.toUpperCase()) {
                        expandedText = expandedText.charAt(0).toUpperCase() + expandedText.slice(1)
                    }

                    expandedText = expandedText.trim();
                    this.writeLastUsedExpansionToLocalStorage(characterNodeExpansions[index]);

                    //now create a range that covers the short code for the expandable
                    var range = document.createRange();
                    range.setStart(recentlyTypedWord.container, recentlyTypedWord.startIndex);
                    range.setEnd(recentlyTypedWord.container, recentlyTypedWord.endIndex);
                    this.$refs.topscribeEditor.selectRange(range); //and select it

                    // handling locked/non breaking spaces
                    var selection = null;
                    var isLocked = characterNodeExpansions[index]['locked'];
                    if (isLocked && expandedText.trim().indexOf(' ') != -1) {
                        // replacing all SPACES with the HEX ASCII code for the space character for non breaking spaces
                        // replacing with &mbsp; caused problems with different expansion lengths
                        expandedText = expandedText.replaceAll(' ', '\xa0');
                        this.rteSaveUndoData();
                        this.$refs.topscribeEditor.executeCommand('insertText', expandedText);
                    } else {
                        // default insert case: no lock
                        this.rteSaveUndoData();
                        this.$refs.topscribeEditor.executeCommand('insertText', expandedText);
                        //then insert the expanded text over that selection (which automatically remove the short code)
                    }

                    //and finally position the cursor after the inserted expanded text
                    selection = this.$refs.topscribeEditor.getRange()
                    range = document.createRange();
                    range.setStart(selection.endContainer, selection.endOffset);
                    this.$refs.topscribeEditor.selectRange(range);

                    this.lastUsedExpansion = {
                        short: recentlyTypedWord.word,
                        long: expandedText
                    }
                } else {
                    this.lastUsedExpansion = null;
                }
            },

            documentContentChanged: function () {
                this.resetFindAndReplaceUI();
                if (!this.readonly) this.saveDocumentContent(true, false);
            },

            getCurrentDocumentContent: function () {
                if (!this.editorContentParentElement) {
                    this.editorContentParentElement = $('#topscribeEditorWrapper .e-rte-content .e-content')[0];
                    if (!this.editorContentParentElement) return null;
                }
                var visibleDocumentContent = this.editorContentParentElement.innerHTML;
                var visibleDocumentContentTemplate = document.createElement('template');
                visibleDocumentContentTemplate.innerHTML = visibleDocumentContent;
                var documentContent = '';
                var i = 0;
                while (i < visibleDocumentContentTemplate.content.childNodes.length) {
                    var currentSectionNode = visibleDocumentContentTemplate.content.childNodes[i];
                    if (currentSectionNode.getAttribute('data-type') == 'turnwrapper') {
                        var id = currentSectionNode.id;
                        var currentTurnContent = currentSectionNode.innerHTML;
                        if (currentSectionNode.getAttribute('data-cleared') == 'true') {
                            if (this.turnContent && this.turnContent[id]) currentTurnContent = this.turnContent[id];
                        }
                        documentContent += currentTurnContent;
                    } else {
                        documentContent += currentSectionNode.outerHTML;
                    }
                    i++;
                }
                return documentContent;
            },
            loadConfiguration: function () {
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'topscribeconfiguration/';
                url += this.topscribeDocumentId;
                var thisVueComponent = this;
                return axios
                    .get(url)
                    .then(response => {
                        thisVueComponent.configuration = response.data;
                        thisVueComponent.configurationReady = true;
                        return true;
                    })
                    .catch(ex => {
                        var currentErrors = thisVueComponent.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            thisVueComponent.showErrorsToast(currentErrors);
                        }
                        return false;
                    });
            },
            loadDocumentContent: function () {
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'topscribedocument/';
                url += this.topscribeDocumentId;
                url += '/content';
                if (this.readonly && this.version) url += '/' + this.version;
                this.showValidationMessages = false;
                this.currentValidationMessages = null;
                this.lastValidationTime = null;
                var thisVueComponent = this;
                return axios
                    .get(url)
                    .then(response => {
                        thisVueComponent.setCurrentDocumentContent(response.data);
                        return true;
                    })
                    .catch(ex => {
                        var currentErrors = thisVueComponent.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            thisVueComponent.showErrorsToast(currentErrors);
                        }
                        return false;
                    });
            },
            setRTEContent: function (documentContent) {
                if (documentContent != this.documentContent) {
                    //the new content is different than the previous one, we can simply update the value and the editor will automatically refresh
                    this.documentContent = documentContent;
                }
                if (this.documentContent == null) {
                    this.documentContent = "<p><br/></p>";
                } else {
                    this.documentContent = null;
                }
                Vue.nextTick(() => {
                    Vue.nextTick(() => {
                        this.documentContent = documentContent;
                    });
                });
            },
            setCurrentDocumentContent: function (documentContent) {
                this.observer.disconnect(); //stop watching for intersections
                if (!documentContent) {
                    this.turnContent = null;
                    this.wrapperIdBySectionId = null;
                    this.setRTEContent(null);
                } else if (this.readonly || !this.performanceMode) {
                    this.turnContent = null;
                    this.wrapperIdBySectionId = null;
                    this.setRTEContent(documentContent);
                } else {
                    var turnContent = {};
                    var wrapperIdBySectionId = {};
                    var visibleDocumentContent = '';
                    var documentContentTemplate = document.createElement('template');
                    documentContentTemplate.innerHTML = documentContent;
                    var currentTurnContent = '';
                    var currentWrapperId = newUuid();
                    var i = 0;
                    while (i < documentContentTemplate.content.childNodes.length) {
                        var atTurnEnd = false;
                        var currentSectionNode = documentContentTemplate.content.childNodes[i];
                        if (currentSectionNode.getAttribute('data-type') == 'turn') {
                            if (currentSectionNode.getAttribute('data-sub-type') == 'start') {
                                if (currentTurnContent != '') {
                                    //we have turn content, which means there was an end turn marker missing, lets still treat the content as a turn
                                    turnContent[currentWrapperId] = currentTurnContent;
                                    visibleDocumentContent += '<div id="' + currentWrapperId + '" data-type="turnwrapper">' + currentTurnContent + '</div >';
                                    currentTurnContent = '';
                                    currentWrapperId = newUuid();
                                }
                            } else {
                                atTurnEnd = true;
                            }
                        }
                        currentTurnContent += currentSectionNode.outerHTML;
                        if (currentSectionNode.id) {
                            wrapperIdBySectionId[currentSectionNode.id] = currentWrapperId;
                        }
                        if (atTurnEnd) {
                            turnContent[currentWrapperId] = currentTurnContent;
                            visibleDocumentContent += '<div id="' + currentWrapperId + '" data-type="turnwrapper">' + currentTurnContent + '</div >';
                            currentTurnContent = '';
                            currentWrapperId = newUuid();
                        }
                        i++;
                    }
                    if (currentTurnContent != '') {
                        //we have turn content, which means there was an end turn marker missing, lets still treat the content as a turn
                        turnContent[currentWrapperId] = currentTurnContent;
                        visibleDocumentContent += '<div id="' + currentWrapperId + '" data-type="turnwrapper">' + currentTurnContent + '</div >';
                        currentTurnContent = '';
                        currentWrapperId = newUuid();
                    }
                    this.turnContent = turnContent;
                    this.wrapperIdBySectionId = wrapperIdBySectionId;
                    this.documentContent = visibleDocumentContent;

                    this.observerActive = true;
                    Vue.nextTick(() => {
                        Vue.nextTick(() => {
                            var elements = document.querySelectorAll('div[data-type="turnwrapper"]');
                            if (elements) {
                                elements.forEach(e => {
                                    this.observer.observe(e);
                                });

                            }
                        });
                    });
                }
            },
            wrapSectionsInTurnWrapper: function (sections) {
                if (!sections || (sections.length < 1)) return;
                var wrapperElement = null;
                var wrapperElementId = null;
                var wrapperElementIsNew = false;
                sections.forEach(section => {
                    var currentElement = section;
                    while ((typeof (currentElement.parentNode) != "undefined") &&
                        (currentElement.parentNode != null) &&
                        (currentElement.parentNode != this.editorContentParentElement) &&
                        ($(currentElement.parentNode).data('type') != 'turnwrapper')) {
                        currentElement = currentElement.parentNode;
                    }
                    if (($(section).data('type') == 'turn') && ($(section).data('sub-type') == 'start')) {
                        if (wrapperElement) {
                            this.turnContent[wrapperElement.id] = wrapperElement.innerHTML;
                            if (wrapperElementIsNew) this.observer.observe(wrapperElement);
                        }
                        wrapperElementId = newUuid();
                        if ($(currentElement.parentNode).data('type') != 'turnwrapper') {
                            if (currentElement.previousSibling != null) {
                                wrapperElement =
                                    $('<div id="' + wrapperElementId + '" data-type="turnwrapper" />').insertAfter(currentElement.previousSibling)[0];
                            } else {
                                wrapperElement =
                                    $('<div id="' + wrapperElementId + '" data-type="turnwrapper" />').appendTo(this.editorContentParentElement)[0];
                            }
                            wrapperElementIsNew = true;
                        } else {
                            if (currentElement.previousSibling == null) {
                                wrapperElement =
                                    $('<div id="' + wrapperElementId + '" data-type="turnwrapper" />').insertBefore(currentElement.parentNode)[0];
                            } else {
                                wrapperElement =
                                    $('<div id="' + wrapperElementId + '" data-type="turnwrapper" />').insertAfter(currentElement.parentNode)[0];
                            }
                            wrapperElementIsNew = true;
                        }
                        $(currentElement).appendTo(wrapperElement);
                        if (currentElement.id) this.wrapperIdBySectionId[currentElement.id] = wrapperElementId;
                    }
                    else if (wrapperElement) {
                        $(currentElement).appendTo(wrapperElement);
                        if (currentElement.id) this.wrapperIdBySectionId[currentElement.id] = wrapperElementId;
                    }
                    else if ($(currentElement.parentNode).data('type') != 'turnwrapper') {
                        if ($(currentElement.previousSibling).data('type') == 'turnwrapper') {
                            wrapperElement = currentElement.previousSibling;
                            wrapperElementId = wrapperElement.id;
                            wrapperElementIsNew = false;
                        } else {
                            wrapperElementId = newUuid();
                            if (currentElement.previousSibling != null) {
                                wrapperElement =
                                    $('<div id="' + wrapperElementId + '" data-type="turnwrapper" />').insertAfter(currentElement.previousSibling)[0];
                            } else {
                                wrapperElement =
                                    $('<div id="' + wrapperElementId + '" data-type="turnwrapper" />').appendTo(this.editorContentParentElement)[0];
                            }
                            wrapperElementIsNew = true;
                        }
                        $(currentElement).appendTo(wrapperElement);
                        if (currentElement.id) this.wrapperIdBySectionId[currentElement.id] = wrapperElementId;
                    }
                });
                if (wrapperElement) {
                    this.turnContent[wrapperElement.id] = wrapperElement.innerHTML;
                    if (wrapperElementIsNew) this.observer.observe(wrapperElement);
                }
            },
            handleCopyOrCut: function (e) {
                e.preventDefault();
                var currentEditorRange = this.$refs.topscribeEditor.getRange();
                if (currentEditorRange && !currentEditorRange.collapsed) {
                    let clipboardData = (e.clipboardData || e.originalEvent.clipboardData || window.clipboardData);
                    if (clipboardData) {
                        var selectedContents = currentEditorRange.cloneContents();
                        let divElement = document.createElement('div');
                        divElement.appendChild(selectedContents);
                        clipboardData.setData('topscribe-fragment', divElement.innerHTML);
                        clipboardData.setData('text/plain', divElement.innerText);
                    }
                    if (e.type == 'cut') {
                        currentEditorRange.deleteContents();
                    }
                }

            },
            pasteTopscribeFragment: function (topscribeFragment) {
                this.storeCurrentEditorSelection(null, false);
                if (this.currentEditorSection == null) {
                    this.$bvToast.toast('This action is only valid when the editor is active', {
                        title: 'Invalid Action',
                        variant: 'danger',
                        appendToast: true
                    });
                    this.resetCurrentEditorSelection();
                    return;
                }
                if (!this.currentEditorRangeCollapsed) {
                    this.$bvToast.toast('This action is only valid when nothing is selected in the editor', {
                        title: 'Invalid Action',
                        variant: 'danger',
                        appendToast: true
                    });
                    this.resetCurrentEditorSelection();
                    return;
                }
                var currentSectionType = $(this.currentEditorSection).data('type');
                var toplevelNodeType = null;
                var firstChild = topscribeFragment.firstChild;
                if ((firstChild.nodeName == '#text') ||
                    (firstChild.nodeName == 'SPAN') ||
                    (firstChild.nodeName == 'STRONG') ||
                    (firstChild.nodeName == 'EM') ||
                    (firstChild.nodeName == 'SUB') ||
                    (firstChild.nodeName == 'SUP')) toplevelNodeType = 'text';
                else if (firstChild.nodeName == 'P') toplevelNodeType = 'paragraph';
                else if (firstChild.nodeName == 'DIV') {
                    var sectionType = $(firstChild).data('type');
                    if (sectionType == 'speaker-subsection') toplevelNodeType = 'speaker-subsection';
                    else if (sectionType == 'speaker') toplevelNodeType = 'speaker-section';
                    else if (sectionType) toplevelNodeType = 'section';
                }
                var currentEditorRange = this.$refs.topscribeEditor.getRange();
                var splitResult = null;
                var insertBefore = null;
                if ((toplevelNodeType == 'text') || (toplevelNodeType == 'paragraph')) {
                    //the content is just one (or more) #text or formated node/s (or one or more paragraphs)
                    //they can only be pasted into a speaker or retaining-style section
                    if ((currentSectionType != 'speaker') &&
                        (currentSectionType != 'retainingstyle')) {
                        this.$bvToast.toast('This action is only valid in a speaker or retaining style section', {
                            title: 'Invalid Action',
                            variant: 'danger',
                            appendToast: true
                        });
                        this.resetCurrentEditorSelection();
                        return;
                    }
                    this.rteSaveUndoData();
                    if (toplevelNodeType == 'text') {
                        while (topscribeFragment.lastChild) {
                            currentEditorRange.insertNode(topscribeFragment.lastChild);
                        }
                    } else if (topscribeFragment.childNodes.length == 1) {
                        var paragraph = topscribeFragment.firstChild;
                        while (paragraph.lastChild) {
                            currentEditorRange.insertNode(paragraph.lastChild);
                        }
                    } else {
                        //we split the current paragraph at the cursor position, then insert the first fragments
                        //paragraph into the paragraph "before" the split, the last fragments paragraph
                        //into the paragraph "before" the split - and all remaining paragraphs into the middle
                        splitResult = this.splitDomTree(currentEditorRange.startContainer, currentEditorRange.startOffset, 'paragraph');
                        var firstParagraph = topscribeFragment.firstChild;
                        if (!splitResult.preParagraph) {
                            //nothing was split, we have been at the very beginning of a paragraph, so we simply insert the
                            //first paragraph (and all others except the last before the postParagraph)
                            splitResult.postParagraph.parentNode.insertBefore(firstParagraph, splitResult.postParagraph);
                        } else {
                            while (firstParagraph.firstChild) {
                                splitResult.preParagraph.appendChild(firstParagraph.firstChild);
                            }
                            topscribeFragment.removeChild(firstParagraph);
                        }
                        var lastParagraph = topscribeFragment.lastChild
                        if (!splitResult.postParagraph) {
                            //nothing was split, we have been at the very end of a paragraph, so we simply insert the
                            //last paragraph (and all others except the last before the postParagraph)
                            if (splitResult.preParagraph.nextSibling)
                                splitResult.preParagraph.parentNode.insertBefore(lastParagraph, splitResult.preParagraph.nextSibling);
                            else
                                splitResult.preParagraph.parentNode.appendChild(lastParagraph);
                        } else {
                            while (lastParagraph.lastChild) {
                                splitResult.postParagraph.insertBefore(lastParagraph.lastChild, splitResult.postParagraph.firstChild);
                            }
                            topscribeFragment.removeChild(lastParagraph);
                        }
                        while (topscribeFragment.firstChild) {
                            if (!splitResult.postParagraph)
                                splitResult.preParagraph.parentNode.insertBefore(topscribeFragment.firstChild, lastParagraph);
                            else
                                splitResult.postParagraph.parentNode.insertBefore(topscribeFragment.firstChild, splitResult.postParagraph);
                        }
                    }
                    this.rteSaveUndoData();
                } else if (toplevelNodeType == 'speaker-subsection') {
                    //the content is one (or more) speaker sub-section (statement, question, answer)
                    //they can only be pasted into a speaker section
                    if (currentSectionType != 'speaker') {
                        this.$bvToast.toast('This action is only valid in a speaker section', {
                            title: 'Invalid Action',
                            variant: 'danger',
                            appendToast: true
                        });
                        this.resetCurrentEditorSelection();
                        return;
                    }
                    this.rteSaveUndoData();
                    if (this.currentSpeakerSubSection) {
                        splitResult = this.splitDomTree(currentEditorRange.startContainer, currentEditorRange.startOffset, 'speaker-subsection');
                        insertBefore = splitResult.postSubsection;
                        if (!insertBefore) {
                            insertBefore = this.currentSpeakerSubSection.nextSibling;
                        }
                    }
                    while (topscribeFragment.firstChild) {
                        var speakerSubSection = topscribeFragment.firstChild;
                        if (insertBefore)
                            this.currentEditorSection.insertBefore(speakerSubSection, insertBefore);
                        else
                            this.currentEditorSection.appendChild(speakerSubSection);
                        this.updateSectionId(speakerSubSection);
                    }
                    this.rteSaveUndoData();
                } else if ((toplevelNodeType == 'speaker-section') || (toplevelNodeType == 'section')) {
                    //the content is one (or more) sections
                    this.rteSaveUndoData();
                    if (currentSectionType == 'speaker') {
                        splitResult = this.splitDomTree(currentEditorRange.startContainer, currentEditorRange.startOffset, 'section');
                        insertBefore = splitResult.postSection;
                    }
                    if (!insertBefore) {
                        insertBefore = this.currentEditorSection.nextSibling;
                    }
                    while (topscribeFragment.firstChild) {
                        var section = topscribeFragment.firstChild;
                        if (insertBefore)
                            this.currentEditorSection.parentNode.insertBefore(section, insertBefore);
                        else
                            this.currentEditorSection.parentNode.appendChild(section);
                        this.updateSectionId(section);
                        var subsections = section.querySelectorAll('div[data-type="speaker-subsection"]');
                        if (subsections) {
                            subsections.forEach(s => this.updateSectionId(s));
                        }
                    }
                    this.restoreDataContent();
                    this.rteSaveUndoData();
                }
            },
            rteActionBegin: function (e) {
                if ((e.originalEvent.action == 'space') &&
                    ((e.requestType == 'OL') || (e.requestType == 'UL'))) {
                    //stop the editor from automatically converting a dash character followed by a space at the beginning of a line to a bullet list
                    e.cancel = true;
                } else if (e.requestType == 'Paste') {
                    let clipboardData = (e.clipboardData || e.originalEvent.clipboardData || window.clipboardData);
                    if (clipboardData) {
                        var data = clipboardData.getData('topscribe-fragment');
                        if (data) {
                            e.cancel = true;
                            let divElement = document.createElement('div');
                            divElement.innerHTML = data;
                            console.log(divElement);
                            this.pasteTopscribeFragment(divElement);
                        }
                    }
                }
            },
            rteActionComplete: function (e) {
                if (!this.readonly && this.performanceMode &&
                    ((e.requestType == 'Undo') || (e.requestType == 'Redo') || (e.requestType == 'Paste'))) {
                    this.observerActive = false;
                    this.observer.disconnect(); //stop watching for intersections
                    this.observerActive = true;
                    Vue.nextTick(() => {
                        Vue.nextTick(() => {
                            var elements = document.querySelectorAll('div[data-type="turnwrapper"]');
                            if (elements) {
                                elements.forEach(e => {
                                    this.observer.observe(e);
                                });

                            }
                        });
                    });
                }
            },
            rteAfterPasteCleanup: function (/*args*/) {
                //do final cleanup of content pasted from word etc.
            },
            rteSaveUndoData: function () {
                if (this.$refs.topscribeEditor &&
                    this.$refs.topscribeEditor.$el &&
                    this.$refs.topscribeEditor.$el.ej2_instances &&
                    this.$refs.topscribeEditor.$el.ej2_instances.length &&
                    this.$refs.topscribeEditor.$el.ej2_instances[0] &&
                    this.$refs.topscribeEditor.$el.ej2_instances[0].formatter)
                    this.$refs.topscribeEditor.$el.ej2_instances[0].formatter.saveData();
            },
            restoreDataContent: function () {
                $('div[data-content]').each((i, elem) => {
                    $(elem).html($(elem).data('content'));
                });
            },
            saveDocumentContent: function (draft = true, showProgressSpinner = false) {
                this.restoreDataContent();
                if (draft && !showProgressSpinner) { //this is a background save draft - we only perform those if the last draft has been saved more than halve the auto-save interval ago
                    if ((this.saveDraftOnOrAfter) &
                        (this.saveDraftOnOrAfter > this.now())) {
                        return Promise.resolve(true);
                    }
                    if (this.lastDraftSaveTime && this.lastDraftSaveSuccessful) {
                        var noAutoSaveBefore = this.addSeconds(this.lastDraftSaveTime, ((this.autosaveInterval / 1000) / 2)); //the autosaveInterval is in milliseconds
                        if (this.now() < noAutoSaveBefore) {
                            this.saveDraftOnOrAfter = this.addSeconds(this.lastDraftSaveTime, (this.autosaveInterval / 1000)); //we need to make sure that an auto save gets performed eventually - cause if the document content does not change from now on, then it will never happen
                            return Promise.resolve(true);
                        }
                    }
                }
                this.saveDraftOnOrAfter = null;

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'topscribedocument/';
                url += this.topscribeDocumentId;
                if (draft) {
                    url += '/draftcontent';
                } else {
                    url += '/content';
                }
                if (!draft) {
                    this.showValidationMessages = false;
                    this.currentValidationMessages = null;
                    this.lastValidationTime = null;
                }
                var documentContent = this.getCurrentDocumentContent();
                if (documentContent == null) documentContent = "";
                var thisVueComponent = this;
                if (showProgressSpinner) this.showProgressSpinner = true;

                return axios
                    .post(url, JSON.stringify(documentContent), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then((response) => {
                        if (showProgressSpinner) this.showProgressSpinner = false;
                        if (draft) {
                            thisVueComponent.lastDraftSaveSuccessful = true;
                            thisVueComponent.lastDraftSaveTime = this.now();
                            return true;
                        }
                        else {
                            thisVueComponent.lastValidationTime = this.now();
                            var validationResult = response.data;
                            if (validationResult && validationResult.cleanedContent)
                                thisVueComponent.setCurrentDocumentContent(validationResult.cleanedContent);
                            if (validationResult && validationResult.success) {
                                thisVueComponent.$bvToast.toast('Document saved successfully', {
                                    title: 'Document Saved',
                                    variant: 'success',
                                    appendToast: true
                                });
                                return true;
                            } else {
                                thisVueComponent.$bvToast.toast('Error while validating the document', {
                                    title: 'Save Failed',
                                    variant: 'danger',
                                    appendToast: true
                                });
                                thisVueComponent.currentValidationMessages = ((validationResult != null) && (validationResult.validationMessages != null)) ? validationResult.validationMessages : null;
                                thisVueComponent.showValidationMessages = (thisVueComponent.currentValidationMessages != null) && (thisVueComponent.currentValidationMessages.length > 0);
                            }
                        }
                        return false;
                    })
                    .catch(ex => {
                        if (showProgressSpinner) this.showProgressSpinner = false;
                        var currentErrors = thisVueComponent.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            thisVueComponent.showErrorsToast(currentErrors);
                        }
                        if (draft) {
                            thisVueComponent.lastDraftSaveSuccessful = false;
                            thisVueComponent.lastDraftSaveTime = this.now();
                            return true;
                        }
                        return false;
                    });
            },
            discardDocumentDraft: function () {
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'topscribedocument/';
                url += this.topscribeDocumentId;
                url += '/draft';
                var thisVueComponent = this;
                return axios
                    .delete(url)
                    .then(() => {
                        return true;
                    })
                    .catch(ex => {
                        var currentErrors = thisVueComponent.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            thisVueComponent.showErrorsToast(currentErrors);
                        }
                        return false;
                    });
            },
            validateDocumentContent: function () {

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'topscribedocument/';
                url += this.topscribeDocumentId;
                url += '/validate';
                this.showValidationMessages = false;
                this.currentValidationMessages = null;
                this.lastValidationTime = null;
                var documentContent = this.getCurrentDocumentContent();
                if (documentContent == null) documentContent = "";
                var thisVueComponent = this;
                this.showProgressSpinner = true;
                return axios
                    .post(url, JSON.stringify(documentContent), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then((response) => {
                        this.showProgressSpinner = false;
                        thisVueComponent.lastValidationTime = this.now();
                        var validationResult = response.data;
                        if (validationResult && validationResult.cleanedContent)
                            thisVueComponent.setCurrentDocumentContent(validationResult.cleanedContent);
                        if (validationResult && validationResult.success) {
                            thisVueComponent.$bvToast.toast('Document validated successfully', {
                                title: 'Document Validated',
                                variant: 'success',
                                appendToast: true
                            });
                            return true;
                        } else {
                            thisVueComponent.$bvToast.toast('Document validation returned errors', {
                                title: 'Document Validation Failed',
                                variant: 'warning',
                                appendToast: true
                            });
                            thisVueComponent.currentValidationMessages = ((validationResult != null) && (validationResult.validationMessages != null)) ? validationResult.validationMessages : null;
                            thisVueComponent.showValidationMessages = (thisVueComponent.currentValidationMessages != null) && (thisVueComponent.currentValidationMessages.length > 0);
                        }
                        return false;
                    })
                    .catch(ex => {
                        this.showProgressSpinner = false;
                        var currentErrors = thisVueComponent.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            thisVueComponent.showErrorsToast(currentErrors);
                        }
                        return false;
                    });
            },
            exportDocumentContent: function () {
                var documentContent = this.getCurrentDocumentContent();
                if (documentContent == null) documentContent = "";
                var blob = new Blob([documentContent], { type: "text/plain;charset=utf-8" });
                FileSaver.saveAs(blob, this.localFilename);
            },
            importDocumentContent: function () {
                if (this.importFile) {
                    this.$bvModal.msgBoxConfirm([this.$createElement('div', { domProps: { innerHTML: 'Are you sure you want to import the selected file and override the current document content?<br/><br/>This action cannot be undone!' } })], {
                        title: 'Confirm Import Document',
                        size: 'md',
                        okVariant: 'danger',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        centered: true
                    })
                        .then(value => {
                            if (value) {
                                const reader = new FileReader();
                                reader.onload = (e) => {
                                    this.setCurrentDocumentContent(e.target.result);
                                };
                                reader.readAsText(this.importFile);
                            }
                        });
                } else {
                    this.$bvToast.toast('No file selected', {
                        title: 'Import',
                        variant: 'danger',
                        appendToast: true
                    });
                }
            },
            updateStatus: function () {
                if ((this.statusInfo == null) ||
                    (this.statusInfo.status == "ok")) {
                    var url = this.apiBaseUrl;
                    if (!url.endsWith('/')) url += '/';
                    url += 'topscribe/';
                    url += this.topscribeDocumentId;
                    url += '/status';
                    axios
                        .get(url)
                        .then(response => {
                            this.statusInfo = response.data;
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            if (currentErrors.length != 0) {
                                this.showErrorsToast(currentErrors);
                            }
                        });
                }
                if (this.saveDraftOnOrAfter && (this.saveDraftOnOrAfter < this.now())) {
                    this.saveDocumentContent(true, false);
                }
            },
            statusErrorRetry: function () {
                this.statusInfo = null
            },
            statusErrorExit: function () {
                this.$emit('close');
            },

            onAction: function (action) {

                if (action.type == "savedraft") {
                    this.saveDocumentContent(true, true);
                } else if (action.type == "savedraftandexit") {
                    this.saveDocumentContent(true, true)
                        .then((success) => {
                            if (success) this.$emit('close');
                        });
                } else if (action.type == "saveandexit") {
                    this.saveDocumentContent(false, true)
                        .then((success) => {
                            if (success) this.$emit('close');
                        });
                } else if (action.type == "discardandexit") {
                    this.$bvModal.msgBoxConfirm([this.$createElement('div', { domProps: { innerHTML: 'Are you sure you want to discard your modifications and close the document?<br/><br/>This action cannot be undone!' } })], {
                        title: 'Confirm Discard Document',
                        size: 'md',
                        okVariant: 'danger',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        centered: true
                    })
                        .then(value => {
                            if (value) {
                                this.discardDocumentDraft()
                                    .then((success) => {
                                        if (success) this.$emit('close');
                                    });
                            }
                        });
                } else if (action.type == "export") {
                    this.exportDocumentContent();
                } else if (action.type == "import") {
                    this.importFile = null;
                    this.showImportModal = true;
                } else if (action.type == "validate") {
                    this.validateDocumentContent();
                } else if (action.type == "clear") {
                    this.$bvModal.msgBoxConfirm([this.$createElement('div', { domProps: { innerHTML: 'Are you sure you want to clear the whole document?<br/><br/>This action cannot be undone!' } })], {
                        title: 'Confirm Clear Document',
                        size: 'md',
                        okVariant: 'danger',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        centered: true
                    })
                        .then(value => {
                            if (value) {
                                this.setCurrentDocumentContent(null);
                            }
                        });
                } else if (action.type == "exit") {
                    this.$emit('close');
                } else if (action.type == "insert-section") {
                    if (action.dialogName == null) {
                        return;
                    }
                    this.currentSectionMode = 'insert';
                    this.storeCurrentEditorSelection();
                    this.currentDialogInitOptions = action.dialogInitOptions ? action.dialogInitOptions : null;
                    this.openDialog(action.dialogName);
                } else if (action.type == "edit-section") {
                    if (this.currentEditorSection == null) {
                        return;
                    }
                    if (action.dialogName == null) {
                        return;
                    }
                    this.currentSectionMode = 'edit';
                    this.openDialog(action.dialogName);
                } else if (action.type == "edit-current-section") {
                    this.storeCurrentEditorSelection(null, false);
                    var contextMenuItems = null;
                    if (this.currentEditorSection) {
                        var dataType = $(this.currentEditorSection).data('type');
                        var dataSubType = $(this.currentEditorSection).data('sub-type');
                        if (dataType && dataSubType && this.dialogs[dataType + dataSubType] && this.dialogs[dataType + dataSubType].contextMenuItems) {
                            contextMenuItems = this.dialogs[dataType + dataSubType].contextMenuItems
                        } else if (dataType && this.dialogs[dataType] && this.dialogs[dataType].contextMenuItems) {
                            contextMenuItems = this.dialogs[dataType].contextMenuItems
                        }
                    }
                    if (contextMenuItems && contextMenuItems.length) {
                        var editSectionContextMenuItem = contextMenuItems.find(e => e.action?.type == 'edit-section');
                        if (editSectionContextMenuItem) {
                            this.onAction(editSectionContextMenuItem.action);
                        } else {
                            this.resetCurrentEditorSelection();
                        }
                    } else {
                        this.resetCurrentEditorSelection();
                    }
                } else if (action.type == "remove-current-section") {
                    this.storeCurrentEditorSelection(null, false);

                    if (this.currentEditorSection == null) {
                        return;
                    }

                    this.currentSpeakerSubSection = null; //this is to force the removal of the section and not any speaker-subsection

                    this.$bvModal.msgBoxConfirm([this.$createElement('div', { domProps: { innerHTML: 'Are you sure you want to remove the current section?<br/><br/>This action cannot be undone!' } })], {
                        title: 'Confirm Section Removal',
                        size: 'md',
                        okVariant: 'danger',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        centered: true
                    })
                        .then(value => {
                            if (value) {
                                this.removeCurrentSection();
                            }
                            this.resetCurrentEditorSelection();
                        });

                } else if (action.type == "remove-current-speaker-subsection") {
                    this.storeCurrentEditorSelection(null, false);
                    if (this.currentSpeakerSubSection == null) {
                        return;
                    }

                    this.$bvModal.msgBoxConfirm([this.$createElement('div', { domProps: { innerHTML: 'Are you sure you want to remove the current speaker sub-section?<br/><br/>This action cannot be undone!' } })], {
                        title: 'Confirm Section Removal',
                        size: 'md',
                        okVariant: 'danger',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        centered: true
                    })
                        .then(value => {
                            if (value) {
                                this.removeCurrentSection();
                            }
                            this.resetCurrentEditorSelection();
                        });

                } else if (action.type == "remove-section") {
                    if (this.currentEditorSection == null) {
                        return;
                    }

                    this.$bvModal.msgBoxConfirm([this.$createElement('div', { domProps: { innerHTML: 'Are you sure you want to remove the selected section?<br/><br/>This action cannot be undone!' } })], {
                        title: 'Confirm Section Removal',
                        size: 'md',
                        okVariant: 'danger',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        centered: true
                    })
                        .then(value => {
                            if (value) {
                                this.removeCurrentSection();
                            }
                            this.resetCurrentEditorSelection();
                        });
                } else if (action.type == "insert-speaker-subsection") {
                    this.insertSpeakerSubSection(action.subSectionName);
                } else if (action.type == "insert-speaker-subsection-at-start") {
                    if ((this.currentEditorSection == null) ||
                        ($(this.currentEditorSection).data('type') != 'speaker')) {
                        this.$bvToast.toast('This action is only valid in a speaker section', {
                            title: 'Invalid Action',
                            variant: 'danger',
                            appendToast: true
                        });
                        return;
                    }
                    this.currentEditorSectionId = this.currentEditorSection.id;
                    this.currentSectionMode = 'insert';
                    this.openDialog('speakersubsection');
                } else if (action.type == "edit-speaker-subsection") {
                    this.storeCurrentEditorSelection(null, false);
                    if (this.currentSpeakerSubSection == null) {
                        this.$bvToast.toast('This action is only valid in a speaker sub-section', {
                            title: 'Invalid Action',
                            variant: 'danger',
                            appendToast: true
                        });
                        this.resetCurrentEditorSelection();
                        return;
                    }
                    this.currentSectionMode = 'edit';
                    this.openDialog('speakersubsection');
                } else if (action.type == "split-section") {
                    this.storeCurrentEditorSelection(null, false);
                    if ((this.currentEditorSection == null) ||
                        (($(this.currentEditorSection).data('type') != 'speaker') &&
                            ($(this.currentEditorSection).data('type') != 'retainingstyle'))) {
                        this.$bvToast.toast('This action is only valid in a speaker or retaining style section', {
                            title: 'Invalid Action',
                            variant: 'danger',
                            appendToast: true
                        });
                        this.resetCurrentEditorSelection();
                        return;
                    }
                    if (!this.currentEditorRangeCollapsed) {
                        this.$bvToast.toast('This action is only valid when nothing is selected in the editor', {
                            title: 'Invalid Action',
                            variant: 'danger',
                            appendToast: true
                        });
                        this.resetCurrentEditorSelection();
                        return;
                    }

                    var splitResult = this.splitDomTree(this.currentEditorRangeNode, this.currentEditorRangeOffset, 'section');
                    if (splitResult.postParagraph) {
                        if (splitResult.postParagraph.firstChild) this.currentEditorRangeNode = splitResult.postParagraph.firstChild;
                        else this.currentEditorRangeNode = splitResult.postParagraph;
                        this.currentEditorRangeOffset = 0;
                        this.restoreCurrenEditPosition();
                    }
                } else if (action.type == "toggle-quote") {
                    this.toggleQuoteSubSection();
                } else if (action.type == "insert-html") {
                    this.checkForExpansion();
                    if (action.html == null) {
                        return;
                    }
                    this.insertHtml(action.html);
                } else if (action.type == "insert-text") {
                    if (action.text == null) {
                        return;
                    }
                    this.insertText(action.html);
                } else if (action.type == "insert-before") {
                    this.addInsertPosition(true);
                } else if (action.type == "insert-after") {
                    this.addInsertPosition(false);
                } else if (action.type == "sourcecode") {
                    this.showSourceModal = true;
                } else if (action.type == "shortcuts") {
                    this.showShortcutsModal = true;
                } else if (action.type == "about") {
                    this.showAboutModal = true;
                } else if (action.type == "text-format") {
                    this.toggleTextFormat(action.textFormat);
                } else if (action.type == "toggle-performancemode") {
                    var documentContent = this.getCurrentDocumentContent();
                    this.performanceMode = !this.performanceMode;
                    this.setCurrentDocumentContent(documentContent);
                } else if (action.type == "toggle-colormode") {
                    this.colorMode = !this.colorMode;
                    this.saveEditorSettings();
                } else if (action.type == "show-settings-modal") {
                    this.showEditorSettingsModal = !this.showEditorSettingsModal;
                } else if (action.type == "glossary-show") {
                    this.showGlossary = !this.showGlossary;
                } else if (action.type == "shortcuts-show") {
                    this.showShortcutsModal = !this.showShortcutsModal;
                } else if (action.type == "show-shortcuts-sidenav") {
                    this.showFindAndReplaceSideBar = false;
                    this.showShortcutsSideBar = !this.showShortcutsSideBar;
                } else if (action.type == "show-expansion-quickadd") {
                    this.highlightedLong = window.getSelection().toString().trim();
                    this.currentExpansionManagerMode = 'quick-add-expansion';
                    this.storeCurrentEditorSelection(null, false);
                    this.expansionManagerActive = true;
                } else if (action.type == "focus-on-quickcheck") {
                    this.showQuickCheckModal = !this.showQuickCheckModal;
                } else if (action.type == "show-dialog-options") {
                    this.showDocumentNavigator = false;
                    this.showTranscriptionSideBar = !this.showTranscriptionSideBar;
                } else if (action.type == "expansions-show") {
                    this.currentExpansionManagerMode = 'manage-expansions';
                    this.storeCurrentEditorSelection(null, false);
                    this.expansionManagerActive = true;
                } else if (action.type == "find-and-replace") {
                    this.showShortcutsSideBar = false;
                    this.showFindAndReplaceSideBar = !this.showFindAndReplaceSideBar;
                } else if (action.type == "show-document-navigator") {
                    this.showTranscriptionSideBar = false;
                    this.showDocumentNavigator = !this.showDocumentNavigator;

                } else if (action.type == "speaker-consolidation") {
                    this.ensureDialogConfiguration('speaker')
                        .then(result => {
                            if (result === true) {
                                this.speakerConsolidation.speakerSectionDetails = this.findAllSections('speaker');
                                this.speakerConsolidation.dialogOpen = true;
                            } else {
                                this.showErrorsToast(result);
                            }
                        });
                }
                
            },
            removeCurrentSection() {
                if (this.currentSpeakerSubSection) {
                    if ($(this.currentSpeakerSubSection).siblings('div[data-type="speaker-subsection"]').length == 0) {
                        //the user is removing the last speaker sub-section, we need to insert an empty statement sub-section so that the layout an everything else still works properly
                        var speakerSubSection = $('<div data-type="speaker-subsection" data-sub-type="statement"/>')
                            .attr('id', newUuid())
                            .insertAfter(this.currentSpeakerSubSection);
                        $('<p><br/></p>').appendTo(speakerSubSection);
                    }
                    $(this.currentSpeakerSubSection).remove();
                } else if (this.currentEditorSection) {
                    $(this.currentEditorSection).remove();
                }
            },
            splitDomTree: function (splitAtNode, splitAtPosition, splitAt) {
                var currentNode = splitAtNode;
                var isAtStartOfParagraph = false;
                var isAtEndOfParagraph = false;
                if (splitAtPosition == 0) {
                    isAtStartOfParagraph = true;
                }
                if ((splitAtNode.nodeName == "#text") &&
                    (splitAtPosition == splitAtNode.textContent.length)) {
                    isAtEndOfParagraph = true;
                } else if (splitAtNode.childNodes &&
                    (splitAtPosition == splitAtNode.childNodes.length)) {
                    isAtEndOfParagraph = true;
                } else if ((splitAtNode.nodeName == "P") &&
                    splitAtNode.childNodes &&
                    (splitAtPosition == (splitAtNode.childNodes.length - 1)) &&
                    (splitAtNode.lastChild.nodeName == 'BR')) {
                    isAtEndOfParagraph = true;
                }
                while ((currentNode != this.currentEditorSection) &&
                    (currentNode.nodeName != "P") &&
                    currentNode.parentNode) {
                    if (currentNode.parentNode.firstChild != currentNode) isAtStartOfParagraph = false;
                    if (currentNode.parentNode.lastChild != currentNode) isAtEndOfParagraph = false;
                    currentNode = currentNode.parentNode;
                }
                var currentParagraph = null;
                var newParagraph = null;
                var currentSubsection = null;
                var newSubsection = null;
                var currentNodeDataType = null;
                var position = 0;
                var nodePositions = [];
                var currentDepth = 0;
                var currentPosition = 0;
                if (splitAt == 'paragraph') {
                    currentParagraph = currentNode;
                    if (isAtStartOfParagraph) {
                        return { postParagraph: currentParagraph };
                    }
                    if (isAtEndOfParagraph) {
                        return { preParagraph: currentParagraph };
                    }
                    newParagraph = currentParagraph.cloneNode(true);
                    if (currentParagraph.nextSibling)
                        currentParagraph.parentNode.insertBefore(newParagraph, currentParagraph.nextSibling);
                    else
                        currentParagraph.parentNode.appendChild(newParagraph);

                    //and then in a first step we remove all nodes "after" the current position
                    currentNode = splitAtNode;
                    if (currentNode.nodeName == '#text') {
                        if (splitAtPosition == 0) currentNode.textContent = "";
                        else if (splitAtPosition < currentNode.textContent.length) {
                            currentNode.textContent = currentNode.textContent.substring(0, splitAtPosition);
                        }
                    }
                    while (currentNode != currentParagraph) {
                        while (currentNode.nextSibling) {
                            currentNode.nextSibling.remove();
                        }
                        //and store the node position
                        position = 0;
                        while (currentNode.previousSibling) {
                            position += 1;
                            currentNode = currentNode.previousSibling;
                        }
                        nodePositions.splice(0, 0, position);
                        currentNode = currentNode.parentNode;
                    }

                    currentNode = newParagraph.firstChild;
                    currentDepth = 0;
                    //and now we always remove all nodes "before" the current position in the cloned section
                    while (currentDepth < nodePositions.length) {
                        currentPosition = nodePositions[currentDepth];
                        while (currentPosition > 0) {
                            currentNode = currentNode.nextSibling;
                            currentNode.previousSibling.remove();
                            currentPosition -= 1;
                        }
                        currentDepth += 1;
                        if (currentDepth == nodePositions.length) {
                            if (currentNode.nodeName == '#text') {
                                if (splitAtPosition == currentNode.textContent.length) currentNode.textContent = "";
                                else if (splitAtPosition > 0) {
                                    currentNode.textContent = currentNode.textContent.substring(splitAtPosition);
                                }
                            }
                        } else {
                            currentNode = currentNode.firstChild;
                        }
                    }
                    return { preParagraph: currentParagraph, postParagraph: newParagraph };
                } else if (splitAt == 'speaker-subsection') {
                    currentParagraph = currentNode;
                    var isAtStartOfSubsection = isAtStartOfParagraph;
                    var isAtEndOfSubsection = isAtEndOfParagraph;
                    currentNodeDataType = $(currentNode).data('type');
                    while ((currentNode != this.currentEditorSection) &&
                        (currentNodeDataType != 'speaker-subsection') &&
                        currentNode.parentNode) {
                        if (currentNode.parentNode.firstChild != currentNode) isAtStartOfSubsection = false;
                        if (currentNode.parentNode.lastChild != currentNode) isAtEndOfSubsection = false;
                        currentNode = currentNode.parentNode;
                        currentNodeDataType = $(currentNode).data('type');
                    }
                    if (isAtStartOfSubsection) {
                        return { postSubsection: currentNode, postParagraph: currentParagraph };
                    }
                    if (isAtEndOfSubsection) {
                        return { preSubsection: currentNode, preParagraph: currentParagraph };
                    }
                    currentSubsection = currentNode;
                    newSubsection = currentSubsection.cloneNode(true);
                    if (currentSubsection.nextSibling)
                        currentSubsection.parentNode.insertBefore(newSubsection, currentSubsection.nextSibling);
                    else
                        currentSubsection.parentNode.appendChild(newSubsection);
                    this.updateSectionId(newSubsection);
                    //and then in a first step we remove all nodes "after" the current position
                    currentNode = splitAtNode;
                    if (currentNode.nodeName == '#text') {
                        if (splitAtPosition == 0) currentNode.textContent = "";
                        else if (splitAtPosition < currentNode.textContent.length) {
                            currentNode.textContent = currentNode.textContent.substring(0, splitAtPosition);
                        }
                    }
                    while (currentNode != currentSubsection) {
                        while (currentNode.nextSibling) {
                            currentNode.nextSibling.remove();
                        }
                        //and store the node position
                        position = 0;
                        while (currentNode.previousSibling) {
                            position += 1;
                            currentNode = currentNode.previousSibling;
                        }
                        nodePositions.splice(0, 0, position);
                        currentNode = currentNode.parentNode;
                    }

                    currentNode = newSubsection.firstChild;
                    currentDepth = 0;
                    //and now we always remove all nodes "before" the current position in the cloned section
                    while (currentDepth < nodePositions.length) {
                        currentPosition = nodePositions[currentDepth];
                        while (currentPosition > 0) {
                            currentNode = currentNode.nextSibling;
                            currentNode.previousSibling.remove();
                            currentPosition -= 1;
                        }
                        if (!newParagraph && (currentNode.nodeName == 'P')) newParagraph = currentNode;
                        currentDepth += 1;
                        if (currentDepth == nodePositions.length) {
                            if (currentNode.nodeName == '#text') {
                                if (splitAtPosition == currentNode.textContent.length) currentNode.textContent = "";
                                else if (splitAtPosition > 0) {
                                    currentNode.textContent = currentNode.textContent.substring(splitAtPosition);
                                }
                            }
                        } else {
                            currentNode = currentNode.firstChild;
                        }
                    }
                    return {
                        preSubsection: currentSubsection,
                        preParagraph: currentParagraph,
                        postSubsection: newSubsection,
                        postParagraph: newParagraph
                    };
                } else if (splitAt == 'section') {
                    currentParagraph = currentNode;
                    var isAtStartOfSection = isAtStartOfParagraph;
                    var isAtEndOfSection = isAtEndOfParagraph;
                    currentNodeDataType = $(currentNode).data('type');
                    while ((currentNode != this.editorContentParentElement) &&
                        currentNode.parentNode &&
                        (currentNode.parentNode != this.editorContentParentElement) &&
                        ($(currentNode.parentNode).data('type') != 'turnwrapper')) {
                        if (currentNode.parentNode.firstChild != currentNode) isAtStartOfSection = false;
                        if (currentNode.parentNode.lastChild != currentNode) isAtEndOfSection = false;
                        if (currentNodeDataType == 'speaker-subsection') {
                            currentSubsection = currentNode;
                        }
                        currentNode = currentNode.parentNode;
                        currentNodeDataType = $(currentNode).data('type');
                    }
                    if (isAtStartOfSection) {
                        return { postSection: currentNode, postParagraph: currentParagraph };
                    }
                    if (isAtEndOfSection) {
                        return { preSection: currentNode, preParagraph: currentParagraph };
                    }
                    var currentSection = currentNode;
                    var newSection = currentSection.cloneNode(true);
                    if (currentSection.nextSibling)
                        currentSection.parentNode.insertBefore(newSection, currentSection.nextSibling);
                    else
                        currentSection.parentNode.appendChild(newSection);
                    this.updateSectionId(newSection);
                    //and then in a first step we remove all nodes "after" the current position
                    currentNode = splitAtNode;
                    if (currentNode.nodeName == '#text') {
                        if (splitAtPosition == 0) currentNode.textContent = "";
                        else if (splitAtPosition < currentNode.textContent.length) {
                            currentNode.textContent = currentNode.textContent.substring(0, splitAtPosition);
                        }
                    }
                    while (currentNode != currentSection) {
                        while (currentNode.nextSibling) {
                            currentNode.nextSibling.remove();
                        }
                        //and store the node position
                        position = 0;
                        while (currentNode.previousSibling) {
                            position += 1;
                            currentNode = currentNode.previousSibling;
                        }
                        nodePositions.splice(0, 0, position);
                        currentNode = currentNode.parentNode;
                    }

                    currentNode = newSection.firstChild;
                    currentDepth = 0;
                    //and now we always remove all nodes "before" the current position in the cloned section
                    while (currentDepth < nodePositions.length) {
                        this.updateSectionId(currentNode); //this takes care of updating IDs for speaker sub-sections
                        currentPosition = nodePositions[currentDepth];
                        while (currentPosition > 0) {
                            currentNode = currentNode.nextSibling;
                            currentNode.previousSibling.remove();
                            currentPosition -= 1;
                        }
                        currentNodeDataType = $(currentNode).data('type');
                        if (!newSubsection && (currentNodeDataType == 'speaker-subsection')) newSubsection = currentNode;
                        if (!newParagraph && (currentNode.nodeName == 'P')) newParagraph = currentNode;
                        currentDepth += 1;
                        if (currentDepth == nodePositions.length) {
                            if (currentNode.nodeName == '#text') {
                                if (splitAtPosition == currentNode.textContent.length) currentNode.textContent = "";
                                else if (splitAtPosition > 0) {
                                    currentNode.textContent = currentNode.textContent.substring(splitAtPosition);
                                }
                            }
                        } else {
                            currentNode = currentNode.firstChild;
                        }
                    }
                    if (this.performanceMode) {
                        this.wrapSectionsInTurnWrapper([newSection]);
                    }
                    return {
                        preSection: currentSection,
                        preSubsection: currentSubsection,
                        preParagraph: currentParagraph,
                        postSection: newSection,
                        postSubsection: newSubsection,
                        postParagraph: newParagraph
                    };
                }
            },

            beforeContextMenuOpen: function (e) {
                var contextMenuItems = [];
                this.storeCurrentEditorSelection(e.event.target, false);
                if (this.currentSpeakerSubSection) {
                    if (this.dialogs.speakersubsection && this.dialogs.speakersubsection.contextMenuItems) {
                        contextMenuItems = this.dialogs.speakersubsection.contextMenuItems
                    }
                } else if (this.currentEditorSection) {
                    var dataType = $(this.currentEditorSection).data('type');
                    var dataSubType = $(this.currentEditorSection).data('sub-type');
                    if (dataType && dataSubType && this.dialogs[dataType + dataSubType] && this.dialogs[dataType + dataSubType].contextMenuItems) {
                        contextMenuItems = this.dialogs[dataType + dataSubType].contextMenuItems
                    } else if (dataType && this.dialogs[dataType] && this.dialogs[dataType].contextMenuItems) {
                        contextMenuItems = this.dialogs[dataType].contextMenuItems
                    }
                    if (!contextMenuItems) contextMenuItems = [];
                    contextMenuItems = contextMenuItems.concat(this.defaultSectionContextMenuItem);
                }
                if (contextMenuItems.length == 0) {
                    this.resetCurrentEditorSelection();
                    e.cancel = true;
                } else {
                    this.contextMenuItems = contextMenuItems;
                    if (this.currentSpeakerSubSection) $(this.currentSpeakerSubSection).addClass('contextmenuActive');
                    else $(this.currentEditorSection).addClass('contextmenuActive');
                }
            },
            beforeMenuItemRender: function (args) {
                if (args.item.toggle) {
                    var text = args.item.text;
                    var icon = null;
                    if (this[args.item.toggle]) {
                        if (args.item.onText) {
                            text = args.item.onText;
                        }
                        if (args.item.onIcon) {
                            icon = args.item.onIcon;
                        } else if (args.item.iconCss) {
                            icon = args.item.iconCss;
                        }
                    } else {
                        if (args.item.offText) {
                            text = args.item.offText;
                        }
                        if (args.item.offIcon) {
                            icon = args.item.offIcon;
                        }
                    }
                    var innerHTML = null;
                    if (icon) {
                        innerHTML = '<span class="e-menu-icon ' + icon + '"></span>';
                    }
                    if (text) {
                        args.element.ariaLabel = text;
                        if (innerHTML) innerHTML += text;
                        else innerHTML = text;
                    }
                    if (innerHTML) args.element.innerHTML = innerHTML;
                }

            },
            menuItemSelected: function (e) {
                if (e.item && e.item.action) {
                    this.onAction(e.item.action);
                }
            },
            contextMenuClosed: function () {
                $('#topscribeEditorWrapper .e-rte-content .e-content .contextmenuActive').removeClass('contextmenuActive');
            },
            openDialog: function (dialogName) {
                if (this.currentEditorSection == null) {
                    return;
                }
                if (typeof this.dialogs[dialogName].dialogConfiguration == "undefined") this.dialogs[dialogName].dialogOpen = true; //the dialog does not have a configuration, no need to load it
                else if (this.dialogs[dialogName].dialogConfiguration) this.dialogs[dialogName].dialogOpen = true; //the configuration is already available locally
                else {
                    this.ensureDialogConfiguration(dialogName)
                        .then(result => {
                            if (result === true) {
                                this.dialogs[dialogName].dialogOpen = true;
                            } else {
                                this.showErrorsToast(result);
                            }
                        });
                }
            },
            ensureDialogConfiguration: function (dialogName) {
                if (typeof this.dialogs[dialogName].dialogConfiguration == "undefined") { //the dialog does not have a configuration, no need to load it
                    return Promise.resolve(true);
                }
                else if (this.dialogs[dialogName].dialogConfiguration) { //the configuration is already available locally
                    return Promise.resolve(true);
                }
                else {
                    var url = this.apiBaseUrl;
                    if (!url.endsWith('/')) url += '/';
                    url += 'topscribedialogconfiguration/';
                    url += dialogName;
                    url += '/';
                    url += this.topscribeDocumentId;
                    return new Promise(resolve => {
                    axios
                        .get(url)
                        .then(response => {
                            this.dialogs[dialogName].dialogConfiguration = response.data;
                                resolve(true);
                        })
                        .catch(ex => {
                                var currentErrors = this.handleAxiosException(ex);
                                resolve(currentErrors);
                        });
                    });
                }
            },
            dialogConfigurationChanged: function (data) {
                this.dialogs[data.dialogName].dialogConfiguration = data.configuration;
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'topscribedialogconfiguration/';
                url += data.dialogName;
                url += '/';
                url += this.topscribeDocumentId;
                var currentErrors = [];
                axios
                    .post(url, JSON.stringify(data.configuration), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        if (response.data && response.data.length) {
                            for (var dialogName of response.data) {
                                this.dialogs[dialogName].dialogConfiguration = null;
                            }
                        }
                    })
                    .catch(ex => {
                        currentErrors = this.handleAxiosException(ex);
                    })
                    .finally(() => {
                        if (currentErrors.length != 0) {
                            this.showErrorsToast(currentErrors);
                        }
                    });
            },
            beforeSectionsInsertOrUpdate: function () {
                if (!this.currentEditorSection || !this.currentEditorSection?.parentElement) {
                    if (this.currentEditorSectionId && (this.currentEditorSectionId != "")) {
                        this.currentEditorSection = $('#' + this.currentEditorSectionId)[0];
                        if (this.currentSpeakerSubSectionId && (this.currentSpeakerSubSectionId != "")) {
                            this.currentSpeakerSubSection = $('#' + this.currentSpeakerSubSectionId)[0];
                        }
                    } else {
                        this.storeCurrentEditorSelection();
                    }
                }
                this.rteSaveUndoData();
            },
            sectionsInserted: function (data) {

                if (this.performanceMode) this.observerActive = false;
                this.removePriorEmptySections(data.sections[0]);
                if (this.performanceMode) this.wrapSectionsInTurnWrapper(data.sections);
                var insertPosition = data.insertPosition;
                var insertPositionSectionId = null;
                if (insertPosition == null) {
                    var insertPositionSection = $('<div data-type="insert-position"/>').attr('id', newUuid()).insertAfter(data.sections[data.sections.length - 1])[0];
                    if (this.performanceMode) {
                        this.wrapSectionsInTurnWrapper([insertPositionSection]);
                        insertPositionSectionId = insertPositionSection.id;
                    }
                    insertPosition = $('<p><br></p>').appendTo(insertPositionSection)[0];
                } else if (this.performanceMode) {
                    insertPositionSectionId = data.sections[0].id;
                }
                this.rteSaveUndoData();
                this.afterInsertUpdateCancel(true, insertPosition, insertPositionSectionId, data.sections);
            },
            sectionUpdated: function () {
                //var insertPosition = this.findFirstEditableParagraph(this.currentEditorSection);
                this.rteSaveUndoData();
                this.afterInsertUpdateCancel(true);
            },
            updateSectionId: function (section) {
                if (section.nodeName == "DIV") {
                    var sectionId = $(section).attr('id');
                    if (sectionId) {
                        sectionId = newUuid();
                        $(section).attr('id', sectionId)
                        var base64EncodedMetaData = $(section).data('metadata');
                        if (base64EncodedMetaData) {
                            var metaData = JSON.parse(atob(base64EncodedMetaData));
                            metaData.SectionId = sectionId;
                            base64EncodedMetaData = btoa(JSON.stringify(metaData));
                            $(section).attr('data-metadata', base64EncodedMetaData);
                            $(section).data('metadata', base64EncodedMetaData);
                        }
                    }
                }
            },
            handleDialogActiveChanged: function (active) {
                if (!active) this.dialogCancelled();
            },
            dialogCancelled: function () {
                this.$log.debug('dialogCancelled');
                this.afterInsertUpdateCancel(false);
            },
            afterInsertUpdateCancel(saveDraft, insertPosition = null, insertPositionSectionId = null, insertedSections = null) {
                if (this.performanceMode) this.observerActive = false;
                if (insertPosition && !insertPositionSectionId && this.performanceMode) {
                    insertPositionSectionId = this.findCurrentEditorSectionId(insertPosition);
                }
                Vue.nextTick(() => {
                    if (insertPosition) {
                        this.setEditorInsertPosition(insertPosition, insertPositionSectionId);
                        var promise = this.scrollIntoView(insertPosition, insertedSections);
                        if (promise) {
                            promise.then(() => {
                                this.focusEditor();
                                if (this.performanceMode) this.observerActive = true;
                            });
                        } else {
                            this.focusEditor();
                            if (this.performanceMode) this.observerActive = true;
                        }
                    } else {
                        this.restoreEditorSelection();
                        this.resetCurrentEditorSelection();
                        this.focusEditor();
                        if (this.performanceMode) this.observerActive = true;
                    }
                    if (saveDraft) this.saveDocumentContent(true, false);
                });
            },

            storeCurrentEditorSelection(element, createIfRequired = true) {
                this.currentEditorScrollPos = null;
                this.currentEditorRangeNode = null;
                this.currentEditorRangeOffset = null;
                this.currentEditorRangeCollapsed = false;
                this.currentEditorSection = null;
                this.currentEditorSectionId = null;
                this.currentSpeakerSubSection = null;
                this.currentSpeakerSubSectionId = null;

                if (!this.editorContentParentElement) {
                    this.editorContentParentElement = $('#topscribeEditorWrapper .e-rte-content .e-content')[0];
                    if (!this.editorContentParentElement) return null;
                }
                var currentElement = element;
                if ((typeof currentElement == "undefined") || (currentElement == null)) {
                    this.focusEditor();
                    if (this.$refs.topscribeEditor.getText().replaceAll('\r\n', '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('&nbsp;', '').trim() == '') {
                        if (createIfRequired) {
                            currentElement = $('<div data-type="insert-position"/>').attr('id', newUuid()).appendTo(this.editorContentParentElement)[0];
                            this.currentEditorRangeNode = currentElement;
                            this.currentEditorRangeOffset = 0;
                            this.currentEditorRangeCollapsed = true;
                        } else {
                            return;
                        }
                    } else {
                        var currentEditorRange = this.$refs.topscribeEditor.getRange();
                        currentElement = currentEditorRange.endContainer;
                        this.currentEditorRangeNode = currentElement;
                        this.currentEditorRangeOffset = currentEditorRange.endOffset;
                        this.currentEditorRangeCollapsed = currentEditorRange.collapsed;
                    }
                }
                var currentElementDataType = $(currentElement).data('type');
                while ((currentElement != this.editorContentParentElement) &&
                    (typeof (currentElement.parentNode) != "undefined") &&
                    (currentElement.parentNode != null) &&
                    (currentElement.parentNode != this.editorContentParentElement) &&
                    ($(currentElement.parentNode).data('type') != 'turnwrapper')) {
                    if (currentElementDataType == 'speaker-subsection') {
                        this.currentSpeakerSubSection = currentElement;
                        this.currentSpeakerSubSectionId = currentElement.id;
                    }
                    currentElement = currentElement.parentNode;
                    currentElementDataType = $(currentElement).data('type');
                }
                if (currentElement && (currentElement != this.editorContentParentElement) && (currentElement.parentNode != null)) {
                    this.currentEditorSection = currentElement;
                    this.currentEditorSectionId = currentElement.id;
                }
                if (!this.currentEditorRangeNode) {
                    if (this.currentSpeakerSubSection) {
                        this.currentEditorRangeNode = this.findFirstEditableParagraph(this.currentSpeakerSubSection);
                    } else if (this.currentEditorSection) {
                        this.currentEditorRangeNode = this.findFirstEditableParagraph(this.currentEditorSection);
                    }
                    this.currentEditorRangeOffset = 0;
                    this.currentEditorRangeCollapsed = true;
                }
                this.currentEditorScrollPos = $(this.editorContentParentElement).scrollTop();
            },
            restoreEditorSelection: function () {
                if (this.currentEditorRangeNode) {
                    var offset = 0;
                    if (this.currentEditorRangeOffset) {
                        offset = this.currentEditorRangeOffset;
                    }
                    var range = document.createRange();
                    range.setStart(this.currentEditorRangeNode, offset);
                    this.$refs.topscribeEditor.selectRange(range);
                }
                if ((this.currentEditorScrollPos != null) && ($(this.editorContentParentElement).scrollTop() != this.currentEditorScrollPos)) {
                    $(this.editorContentParentElement).scrollTop(this.currentEditorScrollPos);
                }
            },
            resetCurrentEditorSelection: function () {
                this.currentEditorScrollPos = null;
                this.currentEditorRangeNode = null;
                this.currentEditorRangeOffset = null;
                this.currentEditorRangeCollapsed = false;
                this.currentEditorSection = null;
                this.currentEditorSectionId = null;
                this.currentSpeakerSubSection = null;
                this.currentSpeakerSubSectionId = null;
            },
            findFirstEditableParagraph(element) {
                if (element.childNodes) {
                    for (var i = 0; i < element.childNodes.length; i++) {
                        var childNode = element.childNodes[i];
                        if ($(childNode).attr('contenteditable') != 'false') {
                            if (childNode.tagName == "P") return childNode;
                            var firstEditableParagraph = this.findFirstEditableParagraph(childNode);
                            if (firstEditableParagraph) return firstEditableParagraph;
                        }
                    }
                }
                return null;
            },
            findCurrentEditorSectionId: function (element) {
                var currentEditorSection = this.findCurrentEditorSection(element, false);
                if (currentEditorSection) return currentEditorSection.id;
                return null;
            },
            findCurrentEditorSection: function (element, createIfRequired = true) {
                if (!this.editorContentParentElement) {
                    this.editorContentParentElement = $('#topscribeEditorWrapper .e-rte-content .e-content')[0];
                    if (!this.editorContentParentElement) return null;
                }
                var currentElement = element;
                if ((typeof currentElement == "undefined") || (currentElement == null)) {
                    this.focusEditor();
                    if (this.$refs.topscribeEditor.getText().replaceAll('\r\n', '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('&nbsp;', '').trim() == '') {
                        if (createIfRequired) {
                            currentElement = $('<div data-type="insert-position"/>').attr('id', newUuid()).appendTo(this.editorContentParentElement)[0];
                        } else {
                            return null;
                        }
                    } else {
                        currentElement = this.$refs.topscribeEditor.getRange().endContainer;
                    }
                }
                while ((typeof (currentElement.parentNode) != "undefined") &&
                    (currentElement.parentNode != null) &&
                    (currentElement.parentNode != this.editorContentParentElement) &&
                    ($(currentElement.parentNode).data('type') != 'turnwrapper')) {
                    currentElement = currentElement.parentNode;
                }
                if ((currentElement.parentNode == null) ||
                    ((currentElement.parentNode != this.editorContentParentElement) &&
                        ($(currentElement.parentNode).data('type') != 'turnwrapper'))) {
                    if (createIfRequired) {
                        currentElement = $('<div data-type="insert-position"/>').attr('id', newUuid()).appendTo(this.editorContentParentElement)[0];
                    } else {
                        return null;
                    }
                }
                else if (currentElement.innerText.replaceAll('\r\n', '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('&nbsp;', '').trim() == '') {
                    if (createIfRequired) {
                        currentElement = $('<div data-type="insert-position"/>').attr('id', newUuid()).insertAfter(currentElement)[0];
                    } else {
                        return null;
                    }
                }
                return currentElement;
            },
            removePriorEmptySections: function (sectionElement) {
                var previousSectionElement = $(sectionElement).prev();
                while ((previousSectionElement.length == 1) &&
                    (previousSectionElement.data('type') != 'speaker') &&
                    (previousSectionElement[0].innerText.replaceAll('\r\n', '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('&nbsp;', '').trim() == '')) {
                    previousSectionElement.remove();
                    previousSectionElement = $(sectionElement).prev();
                }
            },
            insertSpeakerSubSection: function (subSectionType) {
                this.storeCurrentEditorSelection(null, false);
                if (!this.currentSpeakerSubSection) {
                    if (!this.currentEditorSection ||
                        ($(this.currentEditorSection).data('type') != 'speaker')) {
                        this.$bvToast.toast('This action is only valid in a speaker section', {
                            title: 'Invalid Action',
                            variant: 'danger',
                            appendToast: true
                        });
                        this.resetCurrentEditorSelection();
                        return;
                    }
                }
                if (!subSectionType) {
                    //this is meant to open the dialog to choose a type for the sub section
                    this.currentSectionMode = 'insert';
                    this.openDialog('speakersubsection');
                } else {
                    var speakerSubSection = this.createSpeakerSubSection(subSectionType);
                    if (!speakerSubSection) {
                        this.resetCurrentEditorSelection();
                        return;
                    }
                    var newSections = [];
                    if (this.currentSpeakerSubSection) {
                        var currentSpeakerSubSection = this.currentSpeakerSubSection;
                        var speakerSubSectionType = $(currentSpeakerSubSection).data('sub-type');
                        if ((speakerSubSectionType == 'statement') &&
                            ((subSectionType == 'answer') ||
                                (subSectionType == 'answer-witness') ||
                                (subSectionType == 'answer-interpreter') ||
                                (subSectionType == 'answer-examinee'))) {
                            //the current speaker subsection is a statement and we are about to insert an answer -> this means the statement was really a question - at least the last paragraph should become a question
                            var lastParagraph = $(currentSpeakerSubSection).children().last();
                            if ((lastParagraph.length == 1) &&
                                ((lastParagraph[0].tagName == 'P') || (lastParagraph[0].tagName == 'p')) &&
                                (lastParagraph[0].innerText.replaceAll('\r\n', '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('&nbsp;', '').trim() != '')) {
                                //the last paragraph of the statement is not empty
                                var questionSubSection = this.createSpeakerSubSection('question');
                                if (!questionSubSection) {
                                    this.resetCurrentEditorSelection();
                                    return;
                                }
                                if ($(currentSpeakerSubSection).children().length == 1) {
                                    //the current statement speaker section only contains that one paragraph -> we can simply convert the statement into a question
                                    $(currentSpeakerSubSection)
                                        .attr('data-sub-type', 'question')
                                        .data('sub-type', 'question') //IMPORTANT! we need to update both, the data-* attribute and the .data entry, because one is the actual HTML that is read by the server and one is the data that jquery stores internally
                                        .removeAttr('data-margintext')
                                        .removeData('margintext');
                                    $('.speaker-subsection-margintext', $(currentSpeakerSubSection)).remove(); //remove the old margin text
                                    if (questionSubSection.data('margintext')) {
                                        $(currentSpeakerSubSection)
                                            .attr('data-margintext', questionSubSection.data('margintext'))
                                            .data('margintext', questionSubSection.data('margintext'));
                                    }
                                } else {
                                    //the current statement speaker section contains more than one paragraphs
                                    lastParagraph.detach();
                                    questionSubSection.append(lastParagraph);
                                    questionSubSection.insertAfter(currentSpeakerSubSection);
                                    newSections.push(questionSubSection[0]);
                                    currentSpeakerSubSection = questionSubSection;
                                }
                            }
                        }
                        speakerSubSection.insertAfter(currentSpeakerSubSection);
                        newSections.push(speakerSubSection[0]);
                    } else if (this.currentEditorSection) {
                        speakerSubSection.appendTo(this.currentEditorSection);
                        newSections.push(speakerSubSection[0]);
                    }
                    var insertPosition = $('<p><br/></p>').appendTo(speakerSubSection)[0];
                    this.sectionsInserted({ sections: [speakerSubSection[0]], insertPosition: insertPosition });
                }
            },
            createSpeakerSubSection: function (subSectionType) {
                var marginText = null;
                if (subSectionType == 'question') {
                    marginText = 'Q.';
                } else if (subSectionType == 'answer') {
                    marginText = 'A.';
                } else if (subSectionType == 'answer-witness') {
                    marginText = 'A. WITNESS:';
                } else if (subSectionType == 'answer-interpreter') {
                    marginText = 'A. INTERPRETER:';
                } else if (subSectionType == 'answer-examinee') {
                    marginText = 'A. EXAMINEE:';
                } else if (subSectionType != 'statement') {
                    return null;
                }
                var speakerSubSection =
                    $('<div data-type="speaker-subsection"/>')
                        .attr('data-sub-type', subSectionType)
                        .attr('id', newUuid());
                if (marginText != null) {
                    speakerSubSection
                        .attr('data-margintext', marginText)
                        .data('margintext', marginText);
                }
                return speakerSubSection;
            },
            findCurrentSpeakerSubSection: function (element) {
                if (!this.editorContentParentElement) {
                    this.editorContentParentElement = $('#topscribeEditorWrapper .e-rte-content .e-content')[0];
                    if (!this.editorContentParentElement) return null;
                }
                var currentElement = element;
                if ((typeof currentElement == "undefined") || (currentElement == null)) {
                    this.focusEditor();
                    if (this.$refs.topscribeEditor.getText().replaceAll('\r\n', '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('&nbsp;', '').trim() == '') {
                        return null;
                    } else {
                        currentElement = this.$refs.topscribeEditor.getRange().endContainer;
                    }
                }
                var currentElementDataType = $(currentElement).data('type');
                while ((currentElementDataType != 'speaker-subsection') &&
                    (typeof currentElement.parentNode != undefined) &&
                    (currentElement.parentNode != null) &&
                    (currentElement.parentNode != this.editorContentParentElement)) {
                    currentElement = currentElement.parentNode;
                    currentElementDataType = $(currentElement).data('type');
                }
                if (currentElementDataType != 'speaker-subsection') {
                    return null;
                }
                return currentElement;
            },
            toggleQuoteSubSection: function () {
                var currentParagraph = this.findCurrentSpeakerSubSectionParagraph();
                if (currentParagraph == null) {
                    this.$bvToast.toast('This action is only valid in a speaker section', {
                        title: 'Invalid Action',
                        variant: 'danger',
                        appendToast: true
                    });
                    return;
                }
                $(currentParagraph).toggleClass('quote');
            },
            findCurrentSpeakerSubSectionParagraph: function () {
                if (!this.editorContentParentElement) {
                    this.editorContentParentElement = $('#topscribeEditorWrapper .e-rte-content .e-content')[0];
                    if (!this.editorContentParentElement) return null;
                }
                var currentElement = null;
                this.focusEditor();
                if (this.$refs.topscribeEditor.getText().replaceAll('\r\n', '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('&nbsp;', '').trim() == '') {
                    return null;
                } else {
                    currentElement = this.$refs.topscribeEditor.getRange().endContainer;
                }
                var currentParagraph = null;
                var currentElementDataType = $(currentElement).data('type');
                while ((currentElementDataType != 'speaker-subsection') &&
                    (typeof currentElement.parentNode != undefined) &&
                    (currentElement.parentNode != null) &&
                    (currentElement.parentNode != this.editorContentParentElement)) {
                    if ((currentElement.tagName == 'P') && (currentParagraph == null)) currentParagraph = currentElement;
                    currentElement = currentElement.parentNode;
                    currentElementDataType = $(currentElement).data('type');
                }
                if (currentElementDataType != 'speaker-subsection') return null;
                return currentParagraph;
            },
            insertHtml: function (html) {
                if (this.performanceMode) this.observerActive = false;
                this.rteSaveUndoData();
                this.$refs.topscribeEditor.executeCommand('insertHTML', html);
                var insertedElement = this.$refs.topscribeEditor.getRange().endContainer.parentNode;
                var insertPosition = insertedElement.nextSibling;
                if (!insertPosition) {
                    insertPosition = $('<br>').insertAfter(insertedElement)[0];
                }
                this.afterInsertUpdateCancel(true, insertPosition);
            },
            insertText: function (text) {
                this.rteSaveUndoData();
                this.$refs.topscribeEditor.executeCommand('insertText', text);
                Vue.nextTick(() => {
                    this.saveDocumentContent(true, false);
                });
            },
            toggleTextFormat: function (textFormat) {
                this.storeCurrentEditorSelection(null, false);
                if (!this.currentEditorSection ||
                    (($(this.currentEditorSection).data('type') != 'retainingstyle') &&
                        ($(this.currentEditorSection).data('type') != 'speaker'))) {
                    this.$bvToast.toast('This action is only valid in a "Retaining Style" or "Speaker" section', {
                        title: 'Invalid Action',
                        variant: 'danger',
                        appendToast: true
                    });
                    this.resetCurrentEditorSelection();
                    return;
                }
                this.resetCurrentEditorSelection();
                this.$refs.topscribeEditor.executeCommand(textFormat);
            },
            addInsertPosition: function (before) {
                if (this.currentEditorSection == null) {
                    return;
                }
                if (this.performanceMode) this.observerActive = false;
                var insertPositionSection = $('<div data-type="insert-position"/>').attr('id', newUuid());
                if (before) {
                    insertPositionSection = insertPositionSection.insertBefore(this.currentEditorSection)[0];
                } else {
                    insertPositionSection = insertPositionSection.insertAfter(this.currentEditorSection)[0];
                }
                var insertPositionSectionId = null;
                if (this.performanceMode) {
                    this.wrapSectionsInTurnWrapper([insertPositionSection]);
                    insertPositionSectionId = insertPositionSection.id;
                }
                var insertPosition = $('<p><br></p>').appendTo(insertPositionSection)[0];
                this.afterInsertUpdateCancel(false, insertPosition, insertPositionSectionId);
            },
            setEditorInsertPosition: function (insertPosition, insertPositionSectionId = null) {
                if (this.performanceMode && insertPositionSectionId) {
                    if (this.wrapperIdBySectionId && this.wrapperIdBySectionId[insertPositionSectionId]) {
                        var wrapperId = this.wrapperIdBySectionId[insertPositionSectionId];
                        var wrapperSection = $('#' + wrapperId);
                        if ((wrapperSection.length == 1) && (wrapperSection[0].getAttribute('data-cleared') == 'true')) {
                            wrapperSection[0].innerHTML = this.turnContent[wrapperId];
                            wrapperSection[0].removeAttribute('style');
                            wrapperSection[0].removeAttribute('data-cleared');
                        }
                    }
                }
                var startNode = null;
                var offset = 0;
                if (insertPosition.tagName == 'P') {
                    startNode = insertPosition;
                } else {
                    startNode = insertPosition.parentNode;
                    while ((offset < startNode.childNodes.length) && (startNode.childNodes[offset] != insertPosition)) {
                        offset++;
                    }
                }
                var range = document.createRange();
                range.setStart(startNode, offset);
                this.$refs.topscribeEditor.selectRange(range);
            },
            scrollIntoView: function (insertPosition, insertedSections, animate = false) {
                if (!this.editorContentParentElement) {
                    this.editorContentParentElement = $('#topscribeEditorWrapper .e-rte-content .e-content')[0];
                    if (!this.editorContentParentElement) return;
                }
                var viewportHeight = $(this.editorContentParentElement).height();
                var insertPositionTop = $(insertPosition).offset().top;
                var insertPositionElementHeight = $(insertPosition).height();
                if (insertPositionElementHeight < 21) insertPositionElementHeight = 21; //this fixes the issue that the <br/> element has a zero height, but the default height of a line is 21
                var relevantTop = insertPositionTop;
                var relevantBottom = insertPositionTop + insertPositionElementHeight;
                if ((insertedSections != null) && (insertedSections.length > 0)) {
                    var insertedSectionsTop = $(insertedSections[0]).offset().top;
                    if ((insertedSectionsTop < relevantTop) && ((relevantBottom - insertedSectionsTop) < viewportHeight)) {
                        relevantTop = insertedSectionsTop;
                    }
                }

                var viewportTop = $(this.editorContentParentElement).scrollTop();
                var newScrollTop = null;
                if (relevantTop < 0) {
                    newScrollTop = viewportTop + relevantTop - $(this.editorContentParentElement).offset().top;
                }
                else if (relevantTop > viewportHeight) {
                    newScrollTop = relevantBottom - viewportHeight + viewportTop - $(this.editorContentParentElement).offset().top;
                }
                if (newScrollTop != null) {
                    if (animate) {
                        return $(this.editorContentParentElement).animate({
                            scrollTop: newScrollTop
                        })
                            .promise();
                    } else {
                        $(this.editorContentParentElement).scrollTop(newScrollTop);
                    }
                }
            },
            focusEditor: function () {
                this.$refs.topscribeEditor.focusIn();
            },
            validationMessageClicked: function (validationMessage) {
                if (this.invalidSectionHighlightTimer) clearTimeout(this.invalidSectionHighlightTimer);
                $('#topscribeEditorWrapper .e-rte-content .e-content .invalidSectionHighlight').removeClass('invalidSectionHighlight');
                if (validationMessage.documentSectionId) {
                    if (this.performanceMode) {
                        if (this.wrapperIdBySectionId && this.wrapperIdBySectionId[validationMessage.documentSectionId]) {
                            var wrapperId = this.wrapperIdBySectionId[validationMessage.documentSectionId];
                            var wrapperSection = $('#' + wrapperId);
                            if ((wrapperSection.length == 1) && (wrapperSection[0].getAttribute('data-cleared') == 'true')) {
                                wrapperSection[0].innerHTML = this.turnContent[wrapperId];
                                wrapperSection[0].removeAttribute('style');
                                wrapperSection[0].removeAttribute('data-cleared');
                            }
                        }
                    }
                    var section = $('#' + validationMessage.documentSectionId);
                    if (section.length == 1) {
                        var currentNode = section[0];
                        if (validationMessage.subNodePositions && validationMessage.subNodePositions.length) {
                            for (var i = 0; i < validationMessage.subNodePositions.length; i++) {
                                var subNodePosition = validationMessage.subNodePositions[i];
                                if (currentNode.childNodes && (currentNode.childNodes.length > subNodePosition)) {
                                    currentNode = currentNode.childNodes[subNodePosition];
                                } else {
                                    break;
                                }
                            }
                        }
                        this.scrollIntoView(currentNode, null, true);
                        $(currentNode).addClass('invalidSectionHighlight');
                        this.invalidSectionHighlightTimer = setTimeout(() => {
                            $('#topscribeEditorWrapper .e-rte-content .e-content .invalidSectionHighlight').removeClass('invalidSectionHighlight');
                        }, 5000)
                    }
                }
            },
            prettyPrintHtml: function (html) {
                var formatted = '';
                if (html) {
                    var reg = /(>)(<)(\/*)/g;
                    html = html.replace(reg, '$1\r\n$2$3');
                    var pad = 0;
                    $.each(html.split('\r\n'), function (index, node) {
                        var indent = 0;
                        if (node.match(/.+<\/\w[^>]*>$/)) {
                            indent = 0;
                        } else if (node.match(/^<\/\w/)) {
                            if (pad != 0) {
                                pad -= 1;
                            }
                        } else if (node.match(/^<\w[^>]*[^/]>.*$/)) {
                            indent = 1;
                        } else {
                            indent = 0;
                        }

                        var padding = '';
                        for (var i = 0; i < pad; i++) {
                            padding += '  ';
                        }

                        formatted += padding + node + '\r\n';
                        pad += indent;
                    });
                }
                return formatted;
            },

            saveExpansionModifications: function () {

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'topscribe/updateexpandables/';

                // get the modifications and prep for axiso call
                var expansionModifications = JSON.parse(localStorage.getItem('systemExpandablesModifications'));

                var currentErrors = [];
                var thisVueComponent = this;
                axios
                    .put(url, JSON.stringify(expansionModifications), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {

                        localStorage.setItem('systemExpandablesModifications', JSON.stringify([]));

                        this.loadExpandables();

                        this.$bvToast.toast('Expansions saved to DB', {
                            title: 'Expansion Manager',
                            variant: 'success',
                            autoHideDelay: 1000,
                            appendToast: true
                        });

                    })
                    .catch(ex => {
                        var currentErrors = thisVueComponent.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            thisVueComponent.showErrorsToast(currentErrors);
                        }
                    })
                    .finally(() => {
                        if (currentErrors.length != 0) {
                            this.showErrorsToast(currentErrors);
                        }
                    });
            },

            loadExpandables: function () {

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'topscribe/getexpandables/';

                var thisVueComponent = this;
                return axios
                    .get(url)
                    .then(response => {
                        thisVueComponent.systemExpandables = (response.data);
                        this.remodelExpansionsJSON();
                        return true;
                    })
                    .catch(ex => {
                        var currentErrors = thisVueComponent.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            thisVueComponent.showErrorsToast(currentErrors);
                        }
                        return false;
                    });
            },

            remodelExpansionsJSON: function () {

                var firstChar = '';
                var lastChar = '';
                var objectCounter = 1;
                var characterArray = [];

                // remodeled expansion only for checkForExpansions
                // all other expanison lookups ==> full list symstemExpandables
                // but: if expansion added ==> also update lookup

                for (var i = 0; i < this.systemExpandables.length; i++) {

                    if (i == 0) {
                        // init
                        firstChar = this.systemExpandables[i].short.substring(0, 1);
                    } else {
                        // all other biz
                        lastChar = this.systemExpandables[i].short.substring(0, 1);

                        if (firstChar != lastChar) {
                            characterArray = this.systemExpandables.slice(i - objectCounter, i);
                            this.systemExpandablesLookup[firstChar] = characterArray;
                            firstChar = lastChar;
                            objectCounter = 1;
                        } else {
                            objectCounter += 1
                        }
                    }
                }
                // write the last character node as the loop exits ...
                characterArray = this.systemExpandables.slice(i - objectCounter, i);
                this.systemExpandablesLookup[firstChar] = characterArray;
            },

            findAllSections: function (sectionType = null) {
                var sections = [];
                if (this.editorContentParentElement != null) {
                    for (var i = 0; i < this.editorContentParentElement.childNodes.length; i++) {
                        var currentSectionNode = this.editorContentParentElement.childNodes[i];
                        var currentSectionType = currentSectionNode.getAttribute('data-type');
                        if ((currentSectionType == null) || (currentSectionType == '')) continue;
                        if ((sectionType != null) && (currentSectionType != sectionType)) continue;
                        var section = {
                            sectionId: currentSectionNode.getAttribute('id'),
                            sectionType: currentSectionNode.getAttribute('data-type'),
                            sectionSubType: currentSectionNode.getAttribute('data-sub-type'),
                            metaData: currentSectionNode.getAttribute('data-metadata'),
                            marginText: currentSectionNode.getAttribute('data-margintext'),
                            content: currentSectionNode.getAttribute('data-content')
                        };
                        sections.push(section);
                    }
                }
                return sections;
            },

            updateSections: function (sectionDetails) {
                this.rteSaveUndoData();
                if (sectionDetails == null) return;
                for (var i = 0; i < sectionDetails.length; i++) {
                    var sectionToUpdate = document.getElementById(sectionDetails[i].sectionId);
                    sectionToUpdate.setAttribute('data-type', sectionDetails[i].sectionType);
                    sectionToUpdate.dataset["type"] = sectionDetails[i].sectionType;
                    if (sectionDetails[i].sectionSubType) {
                        sectionToUpdate.setAttribute('data-sub-type', sectionDetails[i].sectionSubType);
                        sectionToUpdate.dataset["subType"] = sectionDetails[i].sectionSubType;
                    }
                    sectionToUpdate.setAttribute('data-metadata', sectionDetails[i].metaData);
                    sectionToUpdate.dataset["metadata"] = sectionDetails[i].metaData;
                    if (sectionDetails[i].marginText) {
                        sectionToUpdate.setAttribute('data-margintext', sectionDetails[i].marginText);
                        sectionToUpdate.dataset["margintext"] = sectionDetails[i].marginText;
                    }
                    if (sectionDetails[i].content) {
                        sectionToUpdate.setAttribute('data-content', sectionDetails[i].content);
                        sectionToUpdate.dataset["content"] = sectionDetails[i].content;
                    }
                }
                this.rteSaveUndoData();
            },
        },


        mounted: function () {
            $('#shortcut-sidebar, #transcript-sidebar, #search-replace-sidebar, #index-sidebar').css(
                {
                    'height': 'initial',
                    'overflow': 'auto',
                    'top': '6.4rem',
                    'bottom': '2.1rem'
                }
            );
            this.restoreEditorSettings();

            var thisVueapp = this;
            this.observer = new IntersectionObserver(entries => {
                if (thisVueapp.observerActive && entries) {
                    entries.forEach(e => {
                        var id = e.target.id;
                        if (e.isIntersecting) {
                            if (e.target.getAttribute('data-cleared') == 'true') {
                                e.target.innerHTML = thisVueapp.turnContent[id];
                                e.target.removeAttribute('style');
                                e.target.removeAttribute('data-cleared');
                            }
                        } else {
                            if (e.target.getAttribute('data-cleared') != 'true') {
                                thisVueapp.turnContent[id] = e.target.innerHTML;
                                e.target.setAttribute('style', 'height: ' + e.target.clientHeight + 'px;');
                                e.target.innerHTML = '';
                                e.target.setAttribute('data-cleared', 'true');
                            }
                            
                        }
                    })
                }
            }, {
                root: document.querySelector('#topscribeEditorWrapper .e-rte-content .e-content')
            });
            
            this.loadConfiguration()
                .then(() => {
                    this.loadDocumentContent()
                        .then(() => {
                            Vue.nextTick(() => {
                                $('#topscribeEditorWrapper .e-rte-content .e-content .contextmenuActive').removeClass('contextmenuActive');
                                $('#topscribeEditorWrapper .e-rte-content .e-content .invalidSectionHighlight').removeClass('invalidSectionHighlight');
                                this.editorContentParentElement = $('#topscribeEditorWrapper .e-rte-content .e-content')[0];
                                if (this.readonly) {
                                    $('#topscribeEditorWrapper .e-richtexteditor .e-rte-content .e-content').attr('contenteditable', 'false');
                                } else {
                                    this.focusEditor();
                                    if (this.editorContentParentElement.childNodes.length > 0) {
                                        var insertPosition = this.editorContentParentElement.childNodes[this.editorContentParentElement.childNodes.length - 1];
                                        //check if this is a "proper" insert position
                                        var insertPositionRequired = false;
                                        if ($(insertPosition).data('type') == 'turnwrapper') {
                                            if (insertPosition.childNodes.length > 0) insertPosition = insertPosition.childNodes[insertPosition.childNodes.length - 1];
                                            else insertPositionRequired = true;
                                        }
                                        if ($(insertPosition).attr('contenteditable') == 'false') insertPositionRequired = true;
                                        else if ($(insertPosition).data('type') == null) insertPositionRequired = true;
                                        if (insertPositionRequired) {
                                            //the last node is a non-editable section, lets insert an editable insert position
                                            var insertPositionSection = $('<div data-type="insert-position"/>').attr('id', newUuid()).insertAfter(insertPosition);
                                            insertPosition = $('<p><br></p>').appendTo(insertPositionSection)[0];
                                        }
                                        var insertPositionSectionId = this.findCurrentEditorSectionId(insertPosition);
                                        this.setEditorInsertPosition(insertPosition, insertPositionSectionId);
                                        this.scrollIntoView(insertPosition)
                                    }
                                    this.editorContentParentElement.addEventListener('copy', this.handleCopyOrCut);
                                    this.editorContentParentElement.addEventListener('cut', this.handleCopyOrCut);
                                    if (this.$refs.topscribeEditor.getText().replaceAll('\r\n', '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('&nbsp;', '').trim() == '') {
                                        //the document is empty, we open the turn dialog
                                        this.onAction(
                                            {
                                                type: 'insert-section',
                                                dialogName: 'turn',
                                                dialogInitOptions: {
                                                    eventType: 'start'
                                                }
                                            });
                                    }
                                }
                            })
                        });
                });

            //var expandablesModification = localStorage.getItem('systemExpandablesModifications');
            var expandablesModification = JSON.parse(localStorage.getItem('systemExpandablesModifications'));
            if (expandablesModification && expandablesModification.length) {
                // check if there are any remainders to be stored on the server
                // especially: last used cases
                
                this.saveExpansionModifications();
            } else {
                // if the local storage item does not exist for any reason, create ...
                // otherwise using expansions in the editor will fail to update
                localStorage.setItem('systemExpandablesModifications', JSON.stringify([])); // array needs to be stringified !
            }

            this.loadExpandables();
        },
        created: function () {
            if (!this.readonly) {
                window.addEventListener("keydown", this.handleBackspaceOrDeleteKey, true);
                this.statusTimer = setInterval(this.updateStatus, 60000);
            }
        },
        beforeDestroy: function () {
            if (this.invalidSectionHighlightTimer) clearTimeout(this.invalidSectionHighlightTimer);
            if (this.statusTimer) clearInterval(this.statusTimer);
            if (!this.readonly) {
                window.removeEventListener("keydown", this.handleBackspaceOrDeleteKey);
            }
        }
    }
</script>

<style scoped>

    /* class to make LINEBREAK visible */
    >>> div.rte-show-non-prt-chars span[data-type="special"][data-sub-type="linebreak"]::before {
        /* not sure what styling to give to a non breaking hyphen */
        content: "↩";
        position: relative;
    }
    
    /* class to make PARAGRAPH visible */
    /* Default: show ¶ symbol after <p> */
    >>> div.rte-show-non-prt-chars p::after {
        content: "¶";
        font-size: 0.8em;
        opacity: 0.7;
        display: inline-block; /* instead of inline */
        margin-left: 0.3em;
        vertical-align: baseline; /* or text-bottom */
        line-height: 1; /* optional: helps reduce visual wobble */
    }
   
    /* Suppress ¶ symbol for <p><br></p> */
    >>> div.rte-show-non-prt-chars p:has(> br):not(:has(*:not(br)))::after {
        content: "";
    }

    /* this is important */
        >>> .transcript-ribbon-button {
        background-color: grey !important;
        color: white !important;
        font-size: 14px !important;
        padding: 0 10px 0 10px !important;
        width: 100% !important;
        max-width: 200px !important;
    }
    >>> .transcript-ribbon-button:hover {
        background-color: lightcoral !important;
            
    }
    >>> .transcript-ribbon-button:focus {
        background-color: coral !important;
    }

    /* To customize the appearance of the tooltip */
    >>> .custom-tooltip.e-ribbon-tooltip.e-popup {
        border: 2px solid var(--borderColor);
        border-radius: 5px;
        background: var(--black);
    }

    /* To customize the arrow of the tooltip */
    >>> .custom-tooltip.e-ribbon-tooltip .e-arrow-tip .e-arrow-tip-inner.e-tip-top,
    >>> .custom-tooltip.e-ribbon-tooltip .e-arrow-tip .e-arrow-tip-inner.e-tip-bottom {
        color: var(--black);
    }

    >>> .custom-tooltip.e-ribbon-tooltip .e-arrow-tip-outer.e-tip-top {
        border-bottom: 8px solid var(--borderColor);
    }

    >>> .custom-tooltip.e-ribbon-tooltip .e-arrow-tip-outer.e-tip-bottom {
        border-top: 8px solid var(--borderColor);
    }

    /* To change the size of the tooltip title */
    >>> .custom-tooltip.e-ribbon-tooltip .e-tip-content .e-ribbon-tooltip-title {
        font-size: 14px;
    }

    /* To change the size of the tooltip content */
    >>> .custom-tooltip.e-ribbon-tooltip .e-tip-content .e-ribbon-text-container .e-ribbon-tooltip-content {
        font-size: 11px;
    }

    #topscribeEditorWrapper >>> .e-richtexteditor.e-disabled {
        pointer-events: auto;
        opacity: 1;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        user-select: text;
    }

    #topscribeEditorWrapper >>> .e-richtexteditor .e-rte-content {
        overflow: hidden;
    }
    #topscribeEditorWrapper >>> .e-richtexteditor .e-rte-content .e-content {
        font-family: v-bind('editorFontFace');
        font-size: v-bind('editorFontSizeInPx');
        padding: 0 0 4rem 0;
        overflow-y: scroll;
}
    #topscribeEditorWrapper >>> .e-richtexteditor .e-rte-content .e-content p {
        margin: 0 0 0.5rem 0;
    }
    #topscribeEditorWrapper >>> .e-richtexteditor .e-rte-content .e-content p:last-child {
        margin: 0;
    }

    #topscribeEditorWrapper.rte-portrait >>> .e-richtexteditor {
        width: 50% !important;
    }
    #topscribeEditorWrapper.rte-landscape >>> .e-richtexteditor {
        width: 75% !important;
    }
    #topscribeEditorWrapper.rte-fullwidth >>> .e-richtexteditor {
        width: 100% !important;
    }

    >>> div.contextmenuActive {
        border-color: black !important;
    }

    >>> .invalidSectionHighlight {
        border: 1px solid !important;
        border-color: red !important;
    }
    
    >>> div[data-type] {
        padding: 0 5px;
    }

    >>> div[data-type][data-margintext]::before {
        content: attr(data-margintext);
        float: left;
        font-weight: bold;
        margin-right: 1rem;
    }

    >>> div[data-type="turnwrapper"] {
        padding: 0;
    }

    >>> div.rte-color div[data-type="turn"] {
        background-color: black;
        color: white;
    }

    >>> div.rte-color div[data-type="session"] {
        background-color: gray;
        color: black;
    }

    >>> div.rte-color div[data-type="speaker"][data-sub-type="judge"] {
        background-color: #EBFFEB;
        color: #008000;
    }
    >>> div.rte-color div[data-type="speaker"][data-sub-type="counsel"] {
        background-color: #FFE1E1;
        color: #800000;
    }
    >>> div.rte-color div[data-type="speaker"] {
        background-color: #EAEAD6;
        color: #000000;
    }
    >>> div[data-type="speaker"] span.speaker-name {
        float: left;
        font-weight: bold;
        margin-right: 1em;
    }
    >>> div[data-type="speaker-subsection"] {
        padding: 0 0 0 1em;
        clear: left;
        margin-bottom: 0.5rem;
    }
    >>> div[data-type="speaker-subsection"]:last-child {
        margin-bottom: 0;
    }
    >>> div[data-type="speaker-subsection"] span.speaker-subsection-margintext {
        float: left;
        font-weight: bold;
        margin-right: 1em;
    }
    >>> div[data-type="speaker-subsection"][data-sub-type="statement"] {
        padding: 0;
        clear: none;
    }

    >>> div[data-type="speaker-subsection"] p.quote {
        padding-left: 5px;
        margin-left: 2em !important;
    }
    >>> div.rte-color [data-type="speaker-subsection"] p.quote {
        background-color: lightgray;
        margin-left: 2em !important;
    }
     
    >>> div.rte-color div[data-type="exhibit"] {
        background: #E5F5FF;
        color: #00297A;
        font-weight: bold;
    }
    >>> div.rte-color div[data-type="witness"] {
        background: #FFFFFF;
        color: #CC0000;
        font-weight: bold;
    }
    >>> div.rte-color div[data-type="event"] {
        background: #FFFFFF;
        color: #0000FF;
        font-weight: bold;
    }
    >>> div.rte-color div[data-type="miscevent"] {
        background: #008000;
        color: #FFFFFF;
        font-weight: bold;
    }
    
    >>> div.rte-color div[data-type="interpreter"],
    >>> div.rte-color div[data-type="adjournment"],
    >>> div.rte-color div[data-type="address"] {
        color: darkred;
        font-weight: bold;
    }


    >>> div[data-type="chargeandplea"] {
        color: black;
        font-weight: bold;
    }
    >>> div[data-type="chargeandplea"] span.charge-number {
        display: block;
    }
    >>> div[data-type="chargeandplea"] span.charge-description {
        display: block;
        padding-left: 1rem;
    }
    >>> div[data-type="chargeandplea"] span.accused-plea {
        display: block;
    }

    >>> div.rte-color div[data-type="retainingstyle"] {
        background-color: lightgray;
    }

    #statusArea {
        max-height: 40%;
    }


    /*  from here down - copied from ribbon example */

    #pictureList {
        display: none;
        border: 1px;
        box-shadow: 0 0 2px;
    }

    #pictureddl-popup #pictureList {
        display: block;
    }

    #ribbonContainer {
        padding: 20px;
        background-color: #dbdadacc;
        display: flex;
        flex-direction: column;
    }

    #ribbon {
        box-sizing: border-box;
    }

    #ribbonPlaceHolder-default .e-toast-close-icon {
        position: absolute;
        top: 50%;
        right: 2px;
        transform: translateY(-50%);
        margin: 0;
    }

    #ribbonPlaceHolder-default {
        flex-grow: 1;
        background-color: transparent;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 15px;
    }

        #ribbonPlaceHolder-default .content1 {
            background-color: #3a9ae5;
            width: 150px;
            height: 60%;
        }

        #ribbonPlaceHolder-default .content2 {
            background-color: #9d9c9a;
            width: calc(100% - 160px);
            height: 60%;
        }

        #ribbonPlaceHolder-default .content3 {
            background-color: #7f7e7d;
            width: 150px;
            height: calc(40% - 10px);
        }

        #ribbonPlaceHolder-default .content4 {
            background-color: #c8c6c4;
            width: calc(100% - 160px);
            height: calc(40% - 10px);
        }

        #ribbonPlaceHolder-default .e-toast-content {
            padding-right: 25px;
        }

    body[class*="dark"] #ribbonContainer,
    body[class*="high"] #ribbonContainer {
        background: #a7a7a742;
    }

    .e-bigger #pictureList .e-list-header {
        background-color: white;
    }

    body[class*="dark"].e-bigger #pictureList .e-list-header,
    body[class*="high"].e-bigger #pictureList .e-list-header {
        background-color: #212529;
    }

    .e-bigger #pictureList ul {
        padding: 0px;
        margin-top: 0px;
    }

    .font-group .e-ribbon-group-content {
        justify-content: center;
    }

    #default #header_footer .e-ribbon-group-overflow-ddb {
        min-width: 10ch;
    }

    @font-face {
        font-family: 'ribbon';
        src: url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAAKAIAAAwAgT1MvMj1tSgEAAAEoAAAAVmNtYXC1hLXlAAABvAAAAGBnbHlmb3dp4gAAAjwAABCEaGVhZCNI96cAAADQAAAANmhoZWEIUQQQAAAArAAAACRobXR4PAAAAAAAAYAAAAA8bG9jYRpwHeoAAAIcAAAAIG1heHABIgFWAAABCAAAACBuYW1l6nZ4/QAAEsAAAAIZcG9zdLqmtAYAABTcAAAAqQABAAAEAAAAAFwEAAAAAAAD9AABAAAAAAAAAAAAAAAAAAAADwABAAAAAQAAkDMB+V8PPPUACwQAAAAAAOAbWVsAAAAA4BtZWwAAAAAD9AP0AAAACAACAAAAAAAAAAEAAAAPAUoACQAAAAAAAgAAAAoACgAAAP8AAAAAAAAAAQQAAZAABQAAAokCzAAAAI8CiQLMAAAB6wAyAQgAAAIABQMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUGZFZABA5wDnDwQAAAAAXAQAAAAAAAABAAAAAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAAAAAAAgAAAAMAAAAUAAMAAQAAABQABABMAAAACAAIAAIAAOcE5w3nD///AADnAOcG5w///wAAAAAAAAABAAgAEAAeAAAAAQACAAMABAAFAAYABwAIAAkADQAKAAsADgAMAAAAAABcAHwB3gICAi4CvgMaAz4EwAWSBjwHnAfyCEIABgAAAAAD9AN4AAIABQAJAA0AEQA9AAAtAQkBBREFETc1ARcRJzUXNycfARU3Fz8HLw8PDgKmAU7+sv6GAU7+mOL+GOHh9PT03kF0ogsKCAYGAwIBAQMFBwkLDA4PEBETFBQVFg4ODQ0NDQwLDAoLCQkJCIedAVH+spwB6i//AOGK/vBrARBrK3NzdDsgqHOiDg8REBESExIWFBUTExERDw4MCwkHBQMCAQECAwQFBQYHBwkICgoLAAMAAAAAA/QD9AADAAcACwAAARElEQEFESU3BS0BAiwByPwYAcv+NQMB6wH6/gYCKf3jywIa/ebLAh3LO9fXxQAEAAAAAAM4A/QAtQDYAPsBPQAAEx0BHx4VKwEPBh8HIT8HLwYrATU/Hj0BLwUrAQ8GFQ8VKwEvFTUvBisBDwUlFQ8PLw81JRUhNT8PHw4FFR8PMz8OES8PDw7IAQICAwQEBQYGBwcICAkJCQsKCwwLDA0NDQ0ODg4OEJ0GBgUFAwMCAQECAwMFBQYGAXgGBgUFAwMCAQECAwMFBQYGnRAODg4ODQ0NDQwMCwsKCwkJCQgIBwcGBgUEBAMCAgECAwQEBgUHBgYFBQQDAQEBAgIDAwQFCg0OEBITFRYLDAwMDA0MDQ0NDAwMDAwLCxYUEhEPDgsKBAMDAgIBAQICBAUFBgYHBgUEBAMCAdQBAgQFBwcJCwsMDQ0PDw8QEA8PDw0NDAsLCQcHBQQBAgE4/sgBAgQFBwgJCgsMDQ0PDw8QEBAPDg4MDAwKCQcHBQQC/ooBAgQHCAoMDQ8QEhIUFBYWFhYWFBQSEhAPDQwKCQYEAwEEBQcKCwwOEBESExQVFhYWFhUUExIREA4MCwkIBQQCAB0PDw8ODw4ODQ4MDQwMDAsLCgoJCQgICAYHBQUFBAMCAmACAwQEBgYGBgYFBQQDAQEBAQMEBQUGBgYGBgQEAwJgAgIDBAUFBQcHBwgICQkKCgsLDAwMDQ0NDQ4ODw4PDywGBgUFBAMCAgMEBQUGBioNDA0MDAwLFhUTEhEODQoFBAMDAgIBAQICAwMEBQULDg8RExQWFgwMDA0MDSoGBgUFBAMCAgMEBQUGWH0QEA8ODg0MCwoJCAYGAwMBAQMDBgYICQoLDA0ODg8IEIW7fX0QEA8ODg0MCwoJCAYGAwMBAQMDBgYICQoLDA0ODg8QEJynFxUUFBMREA8OCwoJBgUCAgUGCQoLDg8QERMUFBUXAUMXFRUUExIREA4NCwkHBgMBAQMGBwkLDQ4QERITFBUVAAACAAAAAAP0A/QADwATAAABESMRIxEjESMRIxEjESMRAyERIQOhVKZUplSmVFMD6PwYA6H8vgFO/rIB9P4MAu79EgNC/GsD6AADAAAAAAPzA+cAAgAFABgAAAERIRMBEScjFTMRIRUzNTM1IxE3JwchNSMCu/7Y8f6/Z9DQAeJm0NKtT6f+amcCeP67AZr+oAFgXV3+CLy8XgG1vjy3vAAABQAAAAADngP0AAIABgAKABAAbwAAJQc3JQcnPwEHJzcBMQc3AScBHQExERUfDjM1KwEvBhEfBiEVMzUhIy8NPQE/DTMhNSEPDgH+QAwBOtdD2IsgQiL+iyK4AXCQ/VQCAgMDBQUFBgcHBwgJCAmRkQYFBQQEAgIBDRAJCAkJCgHqOf3dCAcHBwYGBgUFBAQDAgIBAQICAwQEBQUGBgYHBwcIAiP93Q4NDAwMCgoKCAgGBgQDAmwRRcXWQ9YHIUMh/uDGMgFwlgEtBwH9UwgICQcIBwYGBgQFAwMCAQE6AgIEBAQFBQJJCAcDAgEBAYzGAgEDAwQEBQUFBgcGBwgHCAcHBwYGBgUFBAMEAgIBOgECAwQGBggICgoLCwwNDQAAAgAAAAAD9AOQADoASAAAASMPGz8SOwEfBBUlASURFSE1IxUhESEVMzUhAuoZGC4rKCYkIR4dGhkWFBMRDw4MCwkJBwYFBwUCAQYGBwcHCAgJEhQVFhYYGBgYGRkYGBgtKSVKAQr+9v0iAptD/esCFUP9ZQKOAQMEBgcICgsMDQ4ODw8QEBEQERAQEA8OHBgUDgsLCwoJCQkIDg0LCggHBQUDAgEBAwUGEH7sAQxB/WZDhUICmkKFAAMAAAAAA/QDtQAFAAoADwAAJSERFyE3JwchJwEFESERAQO2/JSwAgW3FLb+IbABo/4MA+j+DIkBknl6Pnl5ARH7/dsCJQFFAAcAAAAAA/QDrgAGACYARgBmAKYA9gFJAAATNxc3JzcnAQ8GKwEvBj8HHwYPCC8GPQE/BTsBHwUPCC8GPQE/BTsBHwUlDw4rAS8OPw47AR8NJREVHw0zITM/DTURJw8DESERIS8JNT8HISMPDQUfDjsBPwYfBTsBPwY9AS8FPwMvDisBDw35KWoyakz5ARcBAgMFBQYGBwgGBgUFAwIBAQIDBQUGBggHBgYFBQMCgwECAwQGBgYHBwcGBQQEAgIEBAUGBwcHBgYGBAMCgwECAwQFBgcHBwcGBQQDAwMDBAUGBwcHBwYFBAMCAq0BAQIDAwQFBQYHBggHCAgJCAgICAcHBgYFBQQDAwIBAQEBAgMDBAUFBgYHBwgICAgJCAgHCAYHBgUFBAMDAgH8qwICAwQFBgYHBwgICQkJCgK4CgkJCQgIBwcGBgUEAwICOAsLCwv9UgJLBw8NCwkHAwICAQECBAQHBwgK/csKCQkJCAgHBwYGBQQDAgICiQECAwQFBgcICQkKCwsMDA0JCQgJCAgIBwMDYgQFBQUFBQQFDAQCAgICBGEHBwUEAwEBAgMEBQYHCAkJCgsLDAwMDQwMCwsKCQkIBwYFBAMCASZQZjRmKkgBBwcHBgUEBAICBAQFBgcHBwcGBQQDAgEBAgMEBQYHBQcHBgUEAwIBAQIDBAUGBwcHBwYFBAMDAwMEBQYHBQcGBgYEAwIBAQIDBAYGBgcHBwYFBAQCAgQEBQYHBggJBwgHBwYGBQUEBAICAgICAgQEBQUGBgcHCAcJCAgJBwgHBwYGBQUEBAMCAQECAwQEBQUGBgcHCAcJA/1yCgkJCQgICAYGBgUEAwICAgIDBAUGBgYICAgJCQkKAbs5BAMCAf4bAf0FDA4PERIJCQoKCg8PDg4NDQsLAgIDBAUGBgYICAgJCQkVDQwLDAoKCgkHBwcFBAMCAQICAwMEBQYEYgMCAgICAw0EBQUFBQUEBWEFAg0NDg8MDAwLCwoKCAgHBgYEAwICAwQGBgcICAoKCwsMDAACAAAAAAP0A/QAQADAAAABDx8RHx4FHx8/Hy8fDx4DkgEBAwMFBQYICAkJCwsMDQ0ODhAPEREREhITExMUFBQVFRQUFBMTExISERERDxAODg0NDAsLCQkICAYFBQMDAfx7AQIDBAYGCAkKCwwNDg8QEBISExMVFRUWFxcYGBkZGRoaGRkZGBgXFxYVFRUTExISEBAPDg0MCwoJCAYGBAMCAQECAwQGBggJCgsMDQ4PEBASEhMTFRUVFhcXGBgZGRkaGhkZGRgYFxcWFRUVExMSEhAQDw4NDAsKCQgGBgQDAgIAFRQUFBMTExISERERDxAODg0NDAsLCQkICAYFBQMDAQEDJAEBAwMFBQcHCAkJCwsMDQ0ODw8PEREREhITExMUFBQVGhkZGRgYFxcWFRUVExMSEhAQDw4NDAsKCQgGBgQDAgEBAgMEBgYICQoLDA0ODxAQEhITExUVFRYXFxgYGRkZGhoZGRkYGBcXFhUVFRMTEhIQEA8ODQwLCgkIBgYEAwIBAQIDBAYGCAkKCwwNDg8QEBISExMVFRUWFxcYGBkZGQAJAAAAAAP0A9QAAgAHAAsADwATABcAGwA+AHcAAAEVJyUPAT8BJSE1IQUHJzcFITUhBQcnNyUhNSElMx8GFQ8BNzMVDwYjITUjAzU/BTMnDwYVEwEhPw81AScHNS8PIQ8GAQaQAeoEaxMH/p0BOf7HApy4VLv9tQF3/okC8ypSKf1gAXf+iQG5BgUFBAMDAQGzKNoBAQEDAwQFBQb+5PkBAgIDBAUGBUAGBQUDAwICAQEEAVAKCQgICAgHBgYFBQMDAwEBATisjAEBAwMDBQUGBgcICAgICQr+BQkJCAkIBwcBJZWVVwQfbQdSPwG1UbcUPygqUykUPz4CAgMEBQUF6LDiP70FBQUDBAIC+gIYBQUEBAQCAiQGBwgHCAkICf28/vMBAQIDBAQGBQcGCAcJCAkJ+wEzq4uqCQkICQcIBgcGBQQEAwIBAQEBAgMEBAYAAAAABwAAAAAD9AP0ACEAZQCHAKkArADXASsAABMfBzM/Bj0BLwYjDwYFDw4rAS8OPxMfDiUfByE/By8HIQ8GJx8HIT8HLwchDwYlIzUnFTMVDxIVHxAhESMRFR8IMyEzPwg1PwMfBD8HNS8DPwY9AS8OESchIw8IqAECAgQFBQYG2wYGBgQEAwICAwQEBgYG2wYGBQUEAgICjQECAwQFBggICAoKCwsMDA0NDAwLCwoKCAgHBwUEAwIBAQEBAwMDBAUFBgYHBwgICAwLDQwNDAwLCwoKCAgHBwUEAwL9cwECAgQFBQYGARoGBgUFBAMBAQEBAwQFBQYG/uYGBgUFBAICAQECAgQFBQYGAXcHBgUFAwMCAQECAwMFBQYH/okGBgUFBAICAedxPtoUEhIRDQwMCgoKCAgHBgYEBAICAQMEBggKCgwODg8RERETFAH9jj4BAgQHCQoLBgYGAnIGBgYLCgkGBQIBDAsKC5kEBgYGBgUGBQQDAQECAwSZCQcFBQMDAgIDBAUGBwcJCQoLCwwNDe3+PQYGBgsKCQcEAgEBZAcFBgQEAwIBAQIDBAQGBQcGBgUFBAMBAQEBAwQFBQYjDQwMCwsKCQkIBwYGBAMCAgMEBgYHCAkJCgsLDAwNCQkJCQgICAgHBwYGBgUEBAQDAgEBAgMEBQYHCAkKCgoMDAyOBwUGBAQDAgEBAgMEBAYFBwYGBQUEAwEBAQEDBAUFBncHBQYEBAMCAQECAwQEBgUHBgYFBQQDAQEBAQMEBQUGtHEt3NoBAgUGBgcHCQkJCwsLDAwNDQ4NDhMTERERDw4NDAsJCAYFAwFDA2z8lAYGBgsKCQYFAgEBAgUGCQoLBgZUBQYGB5oFAgIBAQEDBAUFBgYGBgUFmw4MDQ0NDQ4PDw4ODg0NDAwLCgoJCAcHBQES7QECBQYJCgsGBgAAAAAEAAAAAAP0A+wAEAAVABkAOwAANxUfAiE/AjUvAiEPAicHPwEnNxcBJzcHFz8GLw8jDwZkAgMFA3wEBAICBAT8gwMEAkUTYWGcK9gBd9hkL9g4CAYFBAIBAQIDBAYHCAkLCgsLDAsMDAsQDw4PDQ0NIAIEBAICBAQFBAMDAQMEgmQlI4OAtQG7tm04tUMMDQ0NDg4NDg0NDQwLCwoIBgYFBAMCAQIEBQgJCwAAAwAAAAAD9APeAAwALgAyAAABIycHJwMzFzczFz8CIRUhFSEVIRUhFSEVIRUhFSEVIRUhFSEVIT8CES8CISURBREBkUE0Lj46OCMvPTQoQYgBNf7LATX+ywE1/ssBNf7LATX+ywE1/ssBiAQEAgIEBP54/aoCQgFW5N0BATre5O/4BWUpPCg8KTwpOyk8KWECBAQCzQQEAg39CGUDvgAAAAAAEgDeAAEAAAAAAAAAAQAAAAEAAAAAAAEABgABAAEAAAAAAAIABwAHAAEAAAAAAAMABgAOAAEAAAAAAAQABgAUAAEAAAAAAAUACwAaAAEAAAAAAAYABgAlAAEAAAAAAAoALAArAAEAAAAAAAsAEgBXAAMAAQQJAAAAAgBpAAMAAQQJAAEADABrAAMAAQQJAAIADgB3AAMAAQQJAAMADACFAAMAAQQJAAQADACRAAMAAQQJAAUAFgCdAAMAAQQJAAYADACzAAMAAQQJAAoAWAC/AAMAAQQJAAsAJAEXIHJpYmJvblJlZ3VsYXJyaWJib25yaWJib25WZXJzaW9uIDEuMHJpYmJvbkZvbnQgZ2VuZXJhdGVkIHVzaW5nIFN5bmNmdXNpb24gTWV0cm8gU3R1ZGlvd3d3LnN5bmNmdXNpb24uY29tACAAcgBpAGIAYgBvAG4AUgBlAGcAdQBsAGEAcgByAGkAYgBiAG8AbgByAGkAYgBiAG8AbgBWAGUAcgBzAGkAbwBuACAAMQAuADAAcgBpAGIAYgBvAG4ARgBvAG4AdAAgAGcAZQBuAGUAcgBhAHQAZQBkACAAdQBzAGkAbgBnACAAUwB5AG4AYwBmAHUAcwBpAG8AbgAgAE0AZQB0AHIAbwAgAFMAdAB1AGQAaQBvAHcAdwB3AC4AcwB5AG4AYwBmAHUAcwBpAG8AbgAuAGMAbwBtAAAAAAIAAAAAAAAACgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwECAQMBBAEFAQYBBwEIAQkBCgELAQwBDQEOAQ8BEAAIM2QtbW9kZWwGc2hhcGVzB2RpY3RhdGUFY2hhcnQKc2NyZWVuc2hvdAlzbWFydC1hcnQFc2hhcmUEcmVhZAp3ZWItbGF5b3V0BG1vZGUFZHJhZnQFcmV1c2UGZWRpdG9yBHdvcmQAAAAAAA==) format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    [class^="sf-icon-"], [class*=" sf-icon-"] {
        font-family: 'ribbon' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .sf-icon-3d-model:before {
        content: "\e700";
    }

    .sf-icon-shapes:before {
        content: "\e701";
    }

    .sf-icon-dictate:before {
        content: "\e702";
    }

    .sf-icon-chart:before {
        content: "\e703";
    }

    .sf-icon-screenshot:before {
        content: "\e704";
    }

    .sf-icon-smart-art:before {
        content: "\e706";
    }

    .sf-icon-share:before {
        content: "\e707";
    }

    .sf-icon-read:before {
        content: "\e708";
    }

    .sf-icon-web-layout:before {
        content: "\e709";
    }

    .sf-icon-mode:before {
        content: "\e70b";
    }

    .sf-icon-draft:before {
        content: "\e70c";
    }

    .sf-icon-reuse:before {
        content: "\e70f";
    }

    .sf-icon-editor:before {
        content: "\e70a";
    }

    .sf-icon-word:before {
        content: "\e70d";
    }

    .e-menu-wrapper ul.e-menu {
        
        font-size: 18px;
    }
    /* ------------------------ */
    @font-face {
        font-family: "Arial-custom";
        src: url("../../fonts/arial-custom.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Arial";
        src: url("../../fonts/arial.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    /* ------------------------ */
    @font-face {
        font-family: "Calibri-custom";
        src: url("../../fonts/calibri-custom.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Calibri";
        src: url("../../fonts/calibri.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    /* ------------------------ */
    @font-face {
        font-family: "Cambria-custom";
        src: url("../../fonts/cambria-custom.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Cambria";
        src: url("../../fonts/cambria.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    /* ------------------------ */
    @font-face {
        font-family: "Courier New-custom";
        src: url("../../fonts/courier-custom.woff2") format("woff2");
        font-weight: 900;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Courier New";
        src: url("../../fonts/courier.woff2") format("woff2");
        font-weight: 900;
        font-style: normal;
        font-display: swap;
    }
    /* ------------------------ */
    @font-face {
        font-family: "Times New Roman-custom";
        src: url("../../fonts/times-custom.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Times New Roman";
        src: url("../../fonts/times.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    /* ------------------------ */
    @font-face {
        font-family: "Verdana-custom";
        src: url("../../fonts/verdana-custom.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: "Verdana";
        src: url("../../fonts/verdana.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

</style>